<template >
  <div class="l-container ConfirmsIndex">
    現在表示数 {{max}}
    <!-- <div>{{obj}}</div> -->

    <i class="fa fa-sort-alpha-desc"></i>ソート<i class="fa fa-fw fa-angle-down"></i>
    <span>
      <template v-if="this.sortColumn === 'id'">ID</template>
      <template v-if="this.sortColumn === 'family_id'">家庭ID</template>
      <!-- <template v&#45;if="this.sortColumn === ''"></template> -->
      <!-- <template v&#45;if="this.sortColumn === ''"></template> -->
      <!-- <template v&#45;if="this.sortColumn === ''"></template> -->
       : {{sortState}}
    </span>

    <h1 class="m-label m-label-custom" @click="switchV('column')" v-bind:class="{ 'slideActive': column }" v-ripple>項目</h1>

    <template v-if="column">
      <div style="display: flex; flex-wrap: wrap">
        <btn class="m-btn--column" @click.native="reset()">RESET</btn>
        <btn class="m-btn--column" @click.native="all()">ALL</btn>
        <btn class="m-btn--column" @click.native="switchV('sending_check')" v-bind:class="{ 'active': sending_check }">体験案内</btn>
        <btn class="m-btn--column" @click.native="switchV('sending_products')" v-bind:class="{ 'active': sending_products }">送るもの</btn>
        <btn class="m-btn--column" @click.native="switchV('sending_method')" v-bind:class="{ 'active': sending_method }">送る方法</btn>
        <btn class="m-btn--column" @click.native="switchV('sending_date')" v-bind:class="{ 'active': sending_date }">郵送・FAX / 予定日</btn>
        <btn class="m-btn--column" @click.native="switchV('sending_time')" v-bind:class="{ 'active': sending_time }">送信時間</btn>
        <btn class="m-btn--column" @click.native="switchV('confirm_check')" v-bind:class="{ 'active': confirm_check }">確認TEL</btn>
        <btn class="m-btn--column" @click.native="switchV('id')" v-bind:class="{ 'active': id }">ID</btn>
        <btn class="m-btn--column" @click.native="switchV('family_id')" v-bind:class="{ 'active': family_id }">家庭ID</btn>
        <btn class="m-btn--column" @click.native="switchV('user_id')" v-bind:class="{ 'active': user_id }">登録者</btn>
        <btn class="m-btn--column" @click.native="switchV('state')" v-bind:class="{ 'active': state }">状態</btn>
        <btn class="m-btn--column" @click.native="switchV('name')" v-bind:class="{ 'active': name }">名前</btn>
        <btn class="m-btn--column" @click.native="switchV('kana')" v-bind:class="{ 'active': kana }">かな</btn>
        <btn class="m-btn--column" @click.native="switchV('zip')" v-bind:class="{ 'active': zip }">郵便番号</btn>
        <btn class="m-btn--column" @click.native="switchV('pref')" v-bind:class="{ 'active': pref }">都道府県</btn>
        <btn class="m-btn--column" @click.native="switchV('address')" v-bind:class="{ 'active': address }">住所</btn>
        <btn class="m-btn--column" @click.native="switchV('tel1')" v-bind:class="{ 'active': tel1 }">携帯TEL</btn>
        <btn class="m-btn--column" @click.native="switchV('tel2')" v-bind:class="{ 'active': tel2 }">固定TEL</btn>
        <btn class="m-btn--column" @click.native="switchV('preferred_contact')" v-bind:class="{ 'active': preferred_contact }">前日確認連絡先</btn>
        <btn class="m-btn--column" @click.native="switchV('contact_timezone')" v-bind:class="{ 'active': contact_timezone }">時間帯</btn>
        <btn class="m-btn--column" @click.native="switchV('fax')" v-bind:class="{ 'active': fax }">FAX</btn>
        <btn class="m-btn--column" @click.native="switchV('mail')" v-bind:class="{ 'active': mail }">MAIL</btn>
        <btn class="m-btn--column" @click.native="switchV('contact_date')" v-bind:class="{ 'active': contact_date }">問合せ日</btn>
        <btn class="m-btn--column" @click.native="switchV('support')" v-bind:class="{ 'active': support }">問合せ結果</btn>
        <btn class="m-btn--column" @click.native="switchV('missing_detail')" v-bind:class="{ 'active': missing_detail }">問合せ結果詳細</btn>
        <btn class="m-btn--column" @click.native="switchV('contact_later')" v-bind:class="{ 'active': contact_later }">今後連絡できるか</btn>
        <btn class="m-btn--column" @click.native="switchV('next_contact_date')" v-bind:class="{ 'active': next_contact_date }">次回連絡予定日</btn>
        <btn class="m-btn--column" @click.native="switchV('result')" v-bind:class="{ 'active': result }">営業結果</btn>
        <btn class="m-btn--column" @click.native="switchV('acquisition_date')" v-bind:class="{ 'active': acquisition_date }">取得日</btn>
        <btn class="m-btn--column" @click.native="switchV('ap_type')" v-bind:class="{ 'active': ap_type }">AP種類</btn>
        <btn class="m-btn--column" @click.native="switchV('medium1')" v-bind:class="{ 'active': medium1 }">媒体1</btn>
        <btn class="m-btn--column" @click.native="switchV('medium2')" v-bind:class="{ 'active': medium2 }">媒体2</btn>
        <btn class="m-btn--column" @click.native="switchV('medium3')" v-bind:class="{ 'active': medium3 }">媒体3</btn>
        <btn class="m-btn--column" @click.native="switchV('hp_type')" v-bind:class="{ 'active': hp_type }">HP種類</btn>
        <btn class="m-btn--column" @click.native="switchV('office_id')" v-bind:class="{ 'active': office_id }">営業所</btn>
        <btn class="m-btn--column" @click.native="switchV('gender')" v-bind:class="{ 'active': gender }">性別</btn>
        <btn class="m-btn--column" @click.native="switchV('school_type')" v-bind:class="{ 'active': school_type }">公/国/私</btn>
        <btn class="m-btn--column" @click.native="switchV('school_name')" v-bind:class="{ 'active': school_name }">学校名</btn>
        <btn class="m-btn--column" @click.native="switchV('school_stage')" v-bind:class="{ 'active': school_stage }">小/中/高/幼</btn>
        <btn class="m-btn--column" @click.native="switchV('grade')" v-bind:class="{ 'active': grade }">学年</btn>
        <btn class="m-btn--column" @click.native="switchV('memo')" v-bind:class="{ 'active': memo }">メモ</btn>
        <btn class="m-btn--column" @click.native="switchV('dm')" v-bind:class="{ 'active': dm }">DM届いた月</btn>
        <btn class="m-btn--column" @click.native="switchV('shop_type')" v-bind:class="{ 'active': shop_type }">店種類</btn>
        <btn class="m-btn--column" @click.native="switchV('shop_name')" v-bind:class="{ 'active': shop_name }">店名</btn>
        <btn class="m-btn--column" @click.native="switchV('contact_method')" v-bind:class="{ 'active': contact_method }">AP連絡方法</btn>
        <btn class="m-btn--column" @click.native="switchV('hp_browse')" v-bind:class="{ 'active': hp_browse }">HP閲覧</btn>
        <btn class="m-btn--column" @click.native="switchV('visit_date')" v-bind:class="{ 'active': visit_date }">訪問日</btn>
        <btn class="m-btn--column" @click.native="switchV('visit_time')" v-bind:class="{ 'active': visit_time }">訪問時間</btn>
        <btn class="m-btn--column" @click.native="switchV('next_visit_date')" v-bind:class="{ 'active': next_visit_date }">保留上げ日</btn>
        <btn class="m-btn--column" @click.native="switchV('next_visit_time')" v-bind:class="{ 'active': next_visit_time }">保留上げ時間</btn>
        <btn class="m-btn--column" @click.native="switchV('person')" v-bind:class="{ 'active': person }">AP応対者</btn>
        <btn class="m-btn--column" @click.native="switchV('note')" v-bind:class="{ 'active': note }">備考</btn>
        <btn class="m-btn--column" @click.native="switchV('contact_person')" v-bind:class="{ 'active': contact_person }">話した相手</btn>
        <btn class="m-btn--column" @click.native="switchV('parking')" v-bind:class="{ 'active': parking }">駐車場</btn>
        <btn class="m-btn--column" @click.native="switchV('parking_note')" v-bind:class="{ 'active': parking_note }">駐車場備考</btn>
        <btn class="m-btn--column" @click.native="switchV('sub_f_name')" v-bind:class="{ 'active': sub_f_name }">サブ名前1</btn>
        <btn class="m-btn--column" @click.native="switchV('sub_l_name')" v-bind:class="{ 'active': sub_l_name }">サブ名前2</btn>
        <btn class="m-btn--column" @click.native="switchV('sub_f_name_kana')" v-bind:class="{ 'active': sub_f_name_kana }">サブかな1</btn>
        <btn class="m-btn--column" @click.native="switchV('sub_l_name_kana')" v-bind:class="{ 'active': sub_l_name_kana }">サブかな2</btn>
        <btn class="m-btn--column" @click.native="switchV('sub_gender')" v-bind:class="{ 'active': sub_gender }">サブ性別</btn>
        <btn class="m-btn--column" @click.native="switchV('sub_school_type')" v-bind:class="{ 'active': sub_school_type }">サブ公/国/私</btn>
        <btn class="m-btn--column" @click.native="switchV('sub_school_name')" v-bind:class="{ 'active': sub_school_name }">サブ学校名</btn>
        <btn class="m-btn--column" @click.native="switchV('sub_school_stage')" v-bind:class="{ 'active': sub_school_stage }">サブ小/中/高/幼</btn>
        <btn class="m-btn--column" @click.native="switchV('sub_grade')" v-bind:class="{ 'active': sub_grade }">サブ学年</btn>
        <btn class="m-btn--column" @click.native="switchV('achievement')" v-bind:class="{ 'active': achievement }">メイン成績</btn>
        <btn class="m-btn--column" @click.native="switchV('learning')" v-bind:class="{ 'active': learning }">メイン習い事</btn>
        <btn class="m-btn--column" @click.native="switchV('learning_start_period')" v-bind:class="{ 'active': learning_start_period }">メイン習い事いつから</btn>
        <btn class="m-btn--column" @click.native="switchV('learning_nervous')" v-bind:class="{ 'active': learning_nervous }">メイン習い事きっかけ</btn>
        <btn class="m-btn--column" @click.native="switchV('learning_result')" v-bind:class="{ 'active': learning_result }">メイン習い事成果</btn>
        <btn class="m-btn--column" @click.native="switchV('learning_continuation')" v-bind:class="{ 'active': learning_continuation }">メイン習い事継続</btn>
        <btn class="m-btn--column" @click.native="switchV('sub_achievement')" v-bind:class="{ 'active': sub_achievement }">サブ成績</btn>
        <btn class="m-btn--column" @click.native="switchV('sub_learning')" v-bind:class="{ 'active': sub_learning }">サブ習い事</btn>
        <btn class="m-btn--column" @click.native="switchV('sub_learning_start_period')" v-bind:class="{ 'active': sub_learning_start_period }">サブ習い事いつから</btn>
        <btn class="m-btn--column" @click.native="switchV('sub_learning_nervous')" v-bind:class="{ 'active': sub_learning_nervous }">サブ習い事きっかけ</btn>
        <btn class="m-btn--column" @click.native="switchV('sub_learning_result')" v-bind:class="{ 'active': sub_learning_result }">サブ習い事成果</btn>
        <btn class="m-btn--column" @click.native="switchV('sub_learning_continuation')" v-bind:class="{ 'active': sub_learning_continuation }">サブ習い事継続</btn>
        <btn class="m-btn--column" @click.native="switchV('attended')" v-bind:class="{ 'active': attended }">当日の同席者</btn>
        <btn class="m-btn--column" @click.native="switchV('fathers_involvement')" v-bind:class="{ 'active': fathers_involvement }">父親の絡み</btn>
        <btn class="m-btn--column" @click.native="switchV('notices')" v-bind:class="{ 'active': notices }">特記事項</btn>
        <btn class="m-btn--column" @click.native="switchV('transmission_item_company')" v-bind:class="{ 'active': transmission_item_company }">会社名</btn>
        <btn class="m-btn--column" @click.native="switchV('transmission_item_course')" v-bind:class="{ 'active': transmission_item_course }">2通りの教え方</btn>
        <btn class="m-btn--column" @click.native="switchV('transmission_item_visitor')" v-bind:class="{ 'active': transmission_item_visitor }">体験はAD</btn>
        <btn class="m-btn--column" @click.native="switchV('transmission_item_purpose')" v-bind:class="{ 'active': transmission_item_purpose }">勧誘する目的</btn>
        <btn class="m-btn--column" @click.native="switchV('transmission_item_requiredtime')" v-bind:class="{ 'active': transmission_item_requiredtime }">体験は2時間</btn>
        <btn class="m-btn--column" @click.native="switchV('created_at')" v-bind:class="{ 'active': created_at }">作成日</btn>
      </div>
    </template>

    <btn class="resetSearch" @click.native="resetSearch">Reset</btn>

    <div style="display: flex; margin-top: 10px">
      <btn class="m-btn--column" @click.native="btn1">資料・体験案内</btn>
      <btn class="m-btn--column" @click.native="btn2">前日確認</btn>
      <btn class="m-btn--column" @click.native="btn3">保留上げ前日確認</btn>
    </div>

    <div class="index-box" @scroll="offset">
      <table-c>

        <tr-c slot="tr-th">
          <td-c class="sticky-1"></td-c>
          <template v-if="sending_check">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.sending_check" :options="maruSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="sending_products"><td-c class="sticky-1"><input v-model="search.sending_products" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sending_method">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.sending_method" :options="sending_methodSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="sending_date"><td-c class="sticky-1"><input v-model="search.sending_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sending_time"><td-c class="sticky-1"><input v-model="search.sending_time" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="confirm_check">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.confirm_check" :options="confirm_checkSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="id"><td-c class="sticky-1"><input v-model="search.id" type="text" @keyup="searchTable()" placeholder="検索"></td-c></template>
          <template v-if="family_id"><td-c class="sticky-1"><input v-model="search.family_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="user_id">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.user_id" :options="users" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="state">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.state" :options="stateSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="name"><td-c class="sticky-1"><input v-model="search.name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="kana"><td-c class="sticky-1"><input v-model="search.kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="zip"><td-c class="sticky-1"><input v-model="search.zip" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="pref">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.pref" :options="prefs" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="address"><td-c class="sticky-1"><input v-model="search.address" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="tel1"><td-c class="sticky-1"><input v-model="search.tel1" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="tel2"><td-c class="sticky-1"><input v-model="search.tel2" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="preferred_contact">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.preferred_contact" :options="preferred_contactSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="contact_timezone"><td-c class="sticky-1"><input v-model="search.contact_timezone" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="fax"><td-c class="sticky-1"><input v-model="search.fax" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="mail"><td-c class="sticky-1"><input v-model="search.mail" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="contact_date"><td-c class="sticky-1"><input v-model="search.contact_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="support">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.support" :options="supportSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="missing_detail">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.missing_detail" :options="missing_detailSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="contact_later">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.contact_later" :options="contact_laterSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="next_contact_date"><td-c class="sticky-1"><input v-model="search.next_contact_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="result">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.result" :options="resultSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="acquisition_date"><td-c class="sticky-1"><input v-model="search.acquisition_date[0]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="acquisition_date"><td-c class="sticky-1"><input v-model="search.acquisition_date[1]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="ap_type">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.ap_type" :options="ap_typeSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="medium1">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.medium1" :options="mediumSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="medium2">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.medium2" :options="mediumSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="medium3">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.medium3" :options="mediumSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="hp_type">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.hp_type" :options="hp_typeSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="office_id">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.office_id" :options="offices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="gender">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.gender" :options="genderSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="school_type">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.school_type" :options="school_typeSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="school_name"><td-c class="sticky-1"><input v-model="search.school_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="school_stage">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.school_stage" :options="school_stageSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="grade">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.grade" :options="gradeSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="memo"><td-c class="sticky-1"><input v-model="search.memo" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="dm"><td-c class="sticky-1"><input v-model="search.dm" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="shop_type">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.shop_type" :options="shop_typeSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="shop_name"><td-c class="sticky-1"><input v-model="search.shop_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="contact_method">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.contact_method" :options="contact_methodSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="hp_browse">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.hp_browse" :options="hp_browseSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="visit_date"><td-c class="sticky-1"><input v-model="search.visit_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="visit_time"><td-c class="sticky-1"><input v-model="search.visit_time" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="next_visit_date"><td-c class="sticky-1"><input v-model="search.next_visit_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="next_visit_time"><td-c class="sticky-1"><input v-model="search.next_visit_time" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="person"><td-c class="sticky-1"><input v-model="search.person" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="note"><td-c class="sticky-1"><input v-model="search.note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="contact_person">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.contact_person" :options="contact_personSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="parking">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.parking" :options="parkingSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="parking_note"><td-c class="sticky-1"><input v-model="search.parking_note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_f_name"><td-c class="sticky-1"><input v-model="search.sub_f_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_l_name"><td-c class="sticky-1"><input v-model="search.sub_l_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_f_name_kana"><td-c class="sticky-1"><input v-model="search.sub_f_name_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_l_name_kana"><td-c class="sticky-1"><input v-model="search.sub_l_name_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_gender">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.sub_gender" :options="genderSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="sub_school_type">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.sub_school_type" :options="school_typeSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="sub_school_name"><td-c class="sticky-1"><input v-model="search.sub_school_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_school_stage">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.sub_school_stage" :options="school_stageSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="sub_grade">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.sub_grade" :options="gradeSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="achievement"><td-c class="sticky-1"><input v-model="search.achievement" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="learning"><td-c class="sticky-1"><input v-model="search.learning" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="learning_start_period"><td-c class="sticky-1"><input v-model="search.learning_start_period" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="learning_nervous"><td-c class="sticky-1"><input v-model="search.learning_nervous" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="learning_result">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.learning_result" :options="learning_resultSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="learning_continuation">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.learning_continuation" :options="learning_continuationSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="sub_achievement"><td-c class="sticky-1"><input v-model="search.sub_achievement" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_learning"><td-c class="sticky-1"><input v-model="search.sub_learning" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_learning_start_period"><td-c class="sticky-1"><input v-model="search.sub_learning_start_period" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_learning_nervous"><td-c class="sticky-1"><input v-model="search.sub_learning_nervous" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_learning_result">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.sub_learning_result" :options="learning_resultSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="sub_learning_continuation">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.sub_learning_continuation" :options="learning_continuationSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="attended"><td-c class="sticky-1"><input v-model="search.attended" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="fathers_involvement">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.fathers_involvement" :options="fathers_involvementSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="notices"><td-c class="sticky-1"><input v-model="search.notices" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="transmission_item_company">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.transmission_item_company" :options="maruSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="transmission_item_course">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.transmission_item_course" :options="maruSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="transmission_item_visitor">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.transmission_item_visitor" :options="maruSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="transmission_item_purpose">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.transmission_item_purpose" :options="maruSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="transmission_item_requiredtime">
            <td-c class="select sticky-1">
              <multiselect @select="select, searchTable()" v-model="watch.transmission_item_requiredtime" :options="maruSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="created_at"><td-c class="sticky-1"><input v-model="search.created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <td-c class="sticky-2"></td-c>
          <template v-if="sending_check">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_sending_check" :options="maruSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="sending_products"><td-c class="sticky-2"><input v-model="search.not_sending_products" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sending_method">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_sending_method" :options="sending_methodSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="sending_date"><td-c class="sticky-2"><input v-model="search.not_sending_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sending_time"><td-c class="sticky-2"><input v-model="search.not_sending_time" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="confirm_check">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_confirm_check" :options="confirm_checkSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="id"><td-c class="sticky-2"><input v-model="search.not_id" type="text" @keyup="searchTable()" placeholder="除外"></td-c></template>
          <template v-if="family_id"><td-c class="sticky-2"><input v-model="search.not_family_id" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="user_id">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_user_id" :options="users" label="user" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="state">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_state" :options="stateSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="name"><td-c class="sticky-2"><input v-model="search.not_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="kana"><td-c class="sticky-2"><input v-model="search.not_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="zip"><td-c class="sticky-2"><input v-model="search.not_zip" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="pref">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_pref" :options="prefs" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="address"><td-c class="sticky-2"><input v-model="search.not_address" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="tel1"><td-c class="sticky-2"><input v-model="search.not_tel1" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="tel2"><td-c class="sticky-2"><input v-model="search.not_tel2" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="preferred_contact">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_preferred_contact" :options="preferred_contactSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="contact_timezone"><td-c class="sticky-2"><input v-model="search.not_contact_timezone" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="fax"><td-c class="sticky-2"><input v-model="search.not_fax" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="mail"><td-c class="sticky-2"><input v-model="search.not_mail" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="contact_date"><td-c class="sticky-2"><input v-model="search.not_contact_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="support">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_support" :options="supportSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="missing_detail">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_missing_detail" :options="missing_detailSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="contact_later">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_contact_later" :options="contact_laterSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="next_contact_date"><td-c class="sticky-1"><input v-model="search.not_next_contact_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="result">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_result" :options="resultSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="acquisition_date"><td-c class="sticky-2"><input v-model="search.not_acquisition_date[0]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="acquisition_date"><td-c class="sticky-2"><input v-model="search.not_acquisition_date[1]" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="ap_type">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_ap_type" :options="ap_typeSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="medium1">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_medium1" :options="mediumSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="medium2">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_medium2" :options="mediumSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="medium3">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_medium3" :options="mediumSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="hp_type">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_hp_type" :options="hp_typeSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="office_id">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_office_id" :options="offices" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="gender">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_gender" :options="genderSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="school_type">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_school_type" :options="school_typeSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="school_name"><td-c class="sticky-2"><input v-model="search.not_school_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="school_stage">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_school_stage" :options="school_stageSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="grade">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_grade" :options="gradeSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="memo"><td-c class="sticky-2"><input v-model="search.not_memo" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="dm"><td-c class="sticky-2"><input v-model="search.not_dm" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="shop_type">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_shop_type" :options="shop_typeSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="shop_name"><td-c class="sticky-2"><input v-model="search.not_shop_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="contact_method">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_contact_method" :options="contact_methodSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="hp_browse">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_hp_browse" :options="hp_browseSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="visit_date"><td-c class="sticky-2"><input v-model="search.not_visit_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="visit_time"><td-c class="sticky-2"><input v-model="search.not_visit_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="next_visit_date"><td-c class="sticky-2"><input v-model="search.not_next_visit_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="next_visit_time"><td-c class="sticky-2"><input v-model="search.not_next_visit_date" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="person"><td-c class="sticky-2"><input v-model="search.not_person" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="note"><td-c class="sticky-2"><input v-model="search.not_note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="contact_person">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_contact_person" :options="contact_personSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="parking">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_parking" :options="parkingSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="parking_note"><td-c class="sticky-2"><input v-model="search.not_parking_note" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_f_name"><td-c class="sticky-2"><input v-model="search.not_sub_f_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_l_name"><td-c class="sticky-2"><input v-model="search.not_sub_l_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_f_name_kana"><td-c class="sticky-2"><input v-model="search.not_sub_f_name_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_l_name_kana"><td-c class="sticky-2"><input v-model="search.not_sub_l_name_kana" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_gender">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_sub_gender" :options="genderSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="sub_school_type">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_sub_school_type" :options="school_typeSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="sub_school_name"><td-c class="sticky-2"><input v-model="search.not_sub_school_name" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_school_stage">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_sub_school_stage" :options="school_stageSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="sub_grade">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_sub_grade" :options="gradeSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="achievement"><td-c class="sticky-2"><input v-model="search.not_achievement" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="learning"><td-c class="sticky-2"><input v-model="search.not_learning" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="learning_start_period"><td-c class="sticky-2"><input v-model="search.not_learning_start_period" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="learning_nervous"><td-c class="sticky-2"><input v-model="search.not_learning_nervous" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="learning_result">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_learning_result" :options="learning_resultSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="learning_continuation">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_learning_continuation" :options="learning_continuationSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="sub_achievement"><td-c class="sticky-2"><input v-model="search.not_sub_achievement" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_learning"><td-c class="sticky-2"><input v-model="search.not_sub_learning" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_learning_start_period"><td-c class="sticky-2"><input v-model="search.not_sub_learning_start_period" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_learning_nervous"><td-c class="sticky-2"><input v-model="search.not_sub_learning_nervous" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="sub_learning_result">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_sub_learning_result" :options="learning_resultSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="sub_learning_continuation">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_sub_learning_continuation" :options="learning_continuationSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="attended"><td-c class="sticky-2"><input v-model="search.not_attended" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="fathers_involvement">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_fathers_involvement" :options="fathers_involvementSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="notices"><td-c class="sticky-2"><input v-model="search.not_notices" type="text" @keyup="searchTable()"></td-c></template>
          <template v-if="transmission_item_company">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_transmission_item_company" :options="maruSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="transmission_item_course">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_transmission_item_course" :options="maruSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="transmission_item_visitor">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_transmission_item_visitor" :options="maruSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="transmission_item_purpose">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_transmission_item_purpose" :options="maruSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="transmission_item_requiredtime">
            <td-c class="select sticky-2">
              <multiselect @select="select, searchTable()" v-model="watch.not_transmission_item_requiredtime" :options="maruSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="created_at"><td-c class="sticky-2"><input v-model="search.not_created_at" type="text" @keyup="searchTable()"></td-c></template>
        </tr-c>

        <tr-c slot="tr-th">
          <th-c class="sticky-3" style="min-width: 40px">更新</th-c>
          <template v-if="sending_check"><th-c class="sticky-3" @click.native='sort("sending_check")' v-ripple>体験案内</th-c></template>
          <template v-if="sending_products"><th-c class="sticky-3" @click.native='sort("sending_products")' v-ripple>送るもの</th-c></template>
          <template v-if="sending_method"><th-c class="sticky-3" @click.native='sort("sending_method")' v-ripple>送る方法</th-c></template>
          <template v-if="sending_date"><th-c class="sticky-3" @click.native='sort("sending_date")' v-ripple>郵送・FAX / 予定日</th-c></template>
          <template v-if="sending_time"><th-c class="sticky-3" @click.native='sort("sending_time")' v-ripple>送信時間</th-c></template>
          <template v-if="confirm_check"><th-c class="sticky-3" @click.native='sort("confirm_check")' v-ripple>確認TEL</th-c></template>
          <template v-if="id"><th-c class="sticky-3" @click.native='sort("id")' v-ripple>ID</th-c></template>
          <template v-if="family_id"><th-c class="sticky-3" @click.native='sort("family_id")' v-ripple>家庭ID</th-c></template>
          <template v-if="user_id"><th-c class="sticky-3" @click.native='sort("user_id")' v-ripple>登録者</th-c></template>
          <template v-if="state"><th-c class="sticky-3" @click.native='sort("state")' v-ripple>状態</th-c></template>
          <template v-if="name"><th-c class="sticky-3" @click.native='sort("name")' v-ripple>名前</th-c></template>
          <template v-if="kana"><th-c class="sticky-3" @click.native='sort("kana")' v-ripple>かな</th-c></template>
          <template v-if="zip"><th-c class="sticky-3" @click.native='sort("zip")' v-ripple>郵便番号</th-c></template>
          <template v-if="pref"><th-c class="sticky-3" @click.native='sort("pref")' v-ripple>都道府県</th-c></template>
          <template v-if="address"><th-c class="sticky-3" @click.native='sort("address")' v-ripple>住所</th-c></template>
          <template v-if="tel1"><th-c class="sticky-3" @click.native='sort("tel1")' v-ripple>携帯TEL</th-c></template>
          <template v-if="tel2"><th-c class="sticky-3" @click.native='sort("tel2")' v-ripple>固定TEL</th-c></template>
          <template v-if="preferred_contact"><th-c class="sticky-3" @click.native='sort("preferred_contact")' v-ripple>前日確認連絡先</th-c></template>
          <template v-if="contact_timezone"><th-c class="sticky-3" @click.native='sort("contact_timezone")' v-ripple>時間帯</th-c></template>
          <template v-if="fax"><th-c class="sticky-3" @click.native='sort("fax")' v-ripple>FAX</th-c></template>
          <template v-if="mail"><th-c class="sticky-3" @click.native='sort("mail")' v-ripple>MAIL</th-c></template>
          <template v-if="contact_date"><th-c class="sticky-3" @click.native='sort("contact_date")' v-ripple>問合せ日</th-c></template>
          <template v-if="support"><th-c class="sticky-3" @click.native='sort("support")' v-ripple>問合せ結果</th-c></template>
          <template v-if="missing_detail"><th-c class="sticky-3" @click.native='sort("missing_detail")' v-ripple>問合せ結果詳細</th-c></template>
          <template v-if="contact_later"><th-c class="sticky-3" @click.native='sort("contact_later")' v-ripple>今後連絡できるか</th-c></template>
          <template v-if="next_contact_date"><th-c class="sticky-3" @click.native='sort("next_contact_date")' v-ripple>次回連絡予定日</th-c></template>
          <template v-if="result"><th-c class="sticky-3" @click.native='sort("result")' v-ripple>営業結果</th-c></template>
          <template v-if="acquisition_date"><th-c class="sticky-3" @click.native='sort("acquisition_date")' v-ripple>取得日</th-c></template>
          <template v-if="acquisition_date"><th-c class="sticky-3" @click.native='sort("acquisition_date")' v-ripple>~取得日</th-c></template>
          <template v-if="ap_type"><th-c class="sticky-3" @click.native='sort("ap_type")' v-ripple>AP種類</th-c></template>
          <template v-if="medium1"><th-c class="sticky-3" @click.native='sort("medium1")' v-ripple>媒体1</th-c></template>
          <template v-if="medium2"><th-c class="sticky-3" @click.native='sort("medium2")' v-ripple>媒体2</th-c></template>
          <template v-if="medium3"><th-c class="sticky-3" @click.native='sort("medium3")' v-ripple>媒体3</th-c></template>
          <template v-if="hp_type"><th-c class="sticky-3" @click.native='sort("hp_type")' v-ripple>HP種類</th-c></template>
          <template v-if="office_id"><th-c class="sticky-3" @click.native='sort("office_id")' v-ripple>営業所</th-c></template>
          <template v-if="gender"><th-c class="sticky-3" @click.native='sort("gender")' v-ripple>性別</th-c></template>
          <template v-if="school_type"><th-c class="sticky-3" @click.native='sort("school_type")' v-ripple>公/国/私</th-c></template>
          <template v-if="school_name"><th-c class="sticky-3" @click.native='sort("school_name")' v-ripple>学校名</th-c></template>
          <template v-if="school_stage"><th-c class="sticky-3" @click.native='sort("school_stage")' v-ripple>小/中/高/幼</th-c></template>
          <template v-if="grade"><th-c class="sticky-3" @click.native='sort("grade")' v-ripple>学年</th-c></template>
          <template v-if="memo"><th-c class="sticky-3" @click.native='sort("memo")' v-ripple>メモ</th-c></template>
          <template v-if="dm"><th-c class="sticky-3" @click.native='sort("dm")' v-ripple>DM届いた月</th-c></template>
          <template v-if="shop_type"><th-c class="sticky-3" @click.native='sort("shop_type")' v-ripple>店種類</th-c></template>
          <template v-if="shop_name"><th-c class="sticky-3" @click.native='sort("shop_name")' v-ripple>店名</th-c></template>
          <template v-if="contact_method"><th-c class="sticky-3" @click.native='sort("contact_method")' v-ripple>AP連絡方法</th-c></template>
          <template v-if="hp_browse"><th-c class="sticky-3" @click.native='sort("hp_browse")' v-ripple>HP閲覧</th-c></template>
          <template v-if="visit_date"><th-c class="sticky-3" @click.native='sort("visit_date")' v-ripple>訪問日</th-c></template>
          <template v-if="visit_time"><th-c class="sticky-3" @click.native='sort("visit_time")' v-ripple>訪問時間</th-c></template>
          <template v-if="next_visit_date"><th-c class="sticky-3" @click.native='sort("next_visit_date")' v-ripple>保留上げ日</th-c></template>
          <template v-if="next_visit_time"><th-c class="sticky-3" @click.native='sort("next_visit_time")' v-ripple>保留上げ時間</th-c></template>
          <template v-if="person"><th-c class="sticky-3" @click.native='sort("person")' v-ripple>AP応対者</th-c></template>
          <template v-if="note"><th-c class="sticky-3" @click.native='sort("note")' v-ripple>備考</th-c></template>
          <template v-if="contact_person"><th-c class="sticky-3" @click.native='sort("contact_person")' v-ripple>話した相手</th-c></template>
          <template v-if="parking"><th-c class="sticky-3" @click.native='sort("parking")' v-ripple>駐車場</th-c></template>
          <template v-if="parking_note"><th-c class="sticky-3" @click.native='sort("parking_note")' v-ripple>駐車場備考</th-c></template>
          <template v-if="sub_f_name"><th-c class="sticky-3" @click.native='sort("sub_f_name")' v-ripple>サブ名前1</th-c></template>
          <template v-if="sub_l_name"><th-c class="sticky-3" @click.native='sort("sub_l_name")' v-ripple>サブ名前2</th-c></template>
          <template v-if="sub_f_name_kana"><th-c class="sticky-3" @click.native='sort("sub_f_name_kana")' v-ripple>サブ名前かな1</th-c></template>
          <template v-if="sub_l_name_kana"><th-c class="sticky-3" @click.native='sort("sub_l_name_kana")' v-ripple>サブ名前かな2</th-c></template>
          <template v-if="sub_gender"><th-c class="sticky-3" @click.native='sort("sub_gender")' v-ripple>サブ性別</th-c></template>
          <template v-if="sub_school_type"><th-c class="sticky-3" @click.native='sort("sub_school_type")' v-ripple>サブ公/国/私</th-c></template>
          <template v-if="sub_school_name"><th-c class="sticky-3" @click.native='sort("sub_school_name")' v-ripple>サブ学校名</th-c></template>
          <template v-if="sub_school_stage"><th-c class="sticky-3" @click.native='sort("sub_school_stage")' v-ripple>サブ小/中/高/幼</th-c></template>
          <template v-if="sub_grade"><th-c class="sticky-3" @click.native='sort("sub_grade")' v-ripple>サブ学年</th-c></template>
          <template v-if="achievement"><th-c class="sticky-3" @click.native='sort("achievement")' v-ripple>メイン成績</th-c></template>
          <template v-if="learning"><th-c class="sticky-3" @click.native='sort("learning")' v-ripple>メイン習い事</th-c></template>
          <template v-if="learning_start_period"><th-c class="sticky-3" @click.native='sort("learning_start_period")' v-ripple>メイン習い事いつから</th-c></template>
          <template v-if="learning_nervous"><th-c class="sticky-3" @click.native='sort("learning_nervous")' v-ripple>メイン習い事きっかけ</th-c></template>
          <template v-if="learning_result"><th-c class="sticky-3" @click.native='sort("learning_result")' v-ripple>メイン習い事成果</th-c></template>
          <template v-if="learning_continuation"><th-c class="sticky-3" @click.native='sort("learning_continuation")' v-ripple>メイン習い事継続</th-c></template>
          <template v-if="sub_achievement"><th-c class="sticky-3" @click.native='sort("sub_achievement")' v-ripple>サブ成績</th-c></template>
          <template v-if="sub_learning"><th-c class="sticky-3" @click.native='sort("sub_learning")' v-ripple>サブ習い事</th-c></template>
          <template v-if="sub_learning_start_period"><th-c class="sticky-3" @click.native='sort("sub_learning_start_period")' v-ripple>サブ習い事いつから</th-c></template>
          <template v-if="sub_learning_nervous"><th-c class="sticky-3" @click.native='sort("sub_learning_nervous")' v-ripple>サブ習い事きっかけ</th-c></template>
          <template v-if="sub_learning_result"><th-c class="sticky-3" @click.native='sort("sub_learning_result")' v-ripple>サブ習い事成果</th-c></template>
          <template v-if="sub_learning_continuation"><th-c class="sticky-3" @click.native='sort("sub_learning_continuation")' v-ripple>サブ習い事継続</th-c></template>
          <template v-if="attended"><th-c class="sticky-3" @click.native='sort("attended")' v-ripple>当日の同席者</th-c></template>
          <template v-if="fathers_involvement"><th-c class="sticky-3" @click.native='sort("fathers_involvement")' v-ripple>父親の絡み</th-c></template>
          <template v-if="notices"><th-c class="sticky-3" @click.native='sort("notices")' v-ripple>特記事項</th-c></template>
          <template v-if="transmission_item_company"><th-c class="sticky-3" @click.native='sort("transmission_item_company")' v-ripple>会社名</th-c></template>
          <template v-if="transmission_item_course"><th-c class="sticky-3" @click.native='sort("transmission_item_course")' v-ripple>2通りの教え方</th-c></template>
          <template v-if="transmission_item_visitor"><th-c class="sticky-3" @click.native='sort("transmission_item_visitor")' v-ripple></th-c>体験はAD</template>
          <template v-if="transmission_item_purpose"><th-c class="sticky-3" @click.native='sort("transmission_item_purpose")' v-ripple></th-c>勧誘目的</template>
          <template v-if="transmission_item_requiredtime"><th-c class="sticky-3" @click.native='sort("transmission_item_requiredtime")' v-ripple></th-c>体験は2時間</template>
          <template v-if="created_at"><th-c class="sticky-3" @click='sort("created_at")' v-ripple>作成日</th-c></template>
        </tr-c>

        <tr-c slot="tr-td" v-for="list in mapAppointments" :key="list.id" class="tr_hover">

          <td-c @click.native="patchConfirm(list)" class="confirm" v-ripple>更新</td-c>

          <template v-if="sending_check">
            <td-c class="select">
              <multiselect @select="select" v-model="list.sending_check" :options="maruSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="sending_products">
            <td-c @click.native='linkAppointment(list)'>{{list.sending_products}}</td-c>
          </template>
          <template v-if="sending_method">
            <td-c @click.native='linkAppointment(list)' v-if="list.sending_method === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sending_method === 1">郵送</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sending_method === 2">FAX</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sending_method === 3">MAIL</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sending_method === 4">持っていく</td-c>
          </template>
          <template v-if="sending_date"><td-c @click.native='linkAppointment(list)'>{{list.sending_date}}</td-c></template>
          <template v-if="sending_time"><td-c @click.native='linkAppointment(list)'>{{list.sending_time}}</td-c></template>
          <template v-if="confirm_check">
            <td-c class="select">
              <multiselect @select="select" v-model="list.confirm_check" :options="confirm_checkSelect" label="name" placeholder="" :show-labels="false"></multiselect>
            </td-c>
          </template>
          <template v-if="id"><td-c @click.native='linkAppointment(list)'>{{list.id}}</td-c></template>
          <template v-if="family_id"><td-c @click.native='linkAppointment(list)'>{{list.family_id}}</td-c></template>
          <template v-if="user_id">
            <td-c @click.native='linkAppointment(list)' v-if="list.user">{{list.user.user}}</td-c>
            <td-c v-else></td-c>
          </template>
          <template v-if="state">
            <td-c @click.native='linkAppointment(list)' v-if="list.state === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.state === 1">新規</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.state === 2">保留上げ</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.state === 3">書換</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.state === 4">内容変更</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.state === 5">引継</td-c>
          </template>
          <template v-if="name"><td-c @click.native='linkAppointment(list)'>{{list.f_name}} {{list.l_name}}</td-c></template>
          <template v-if="kana"><td-c @click.native='linkAppointment(list)'>{{list.f_name_kana}} {{list.l_name_kana}}</td-c></template>
          <template v-if="zip"><td-c @click.native='linkAppointment(list)'>{{list.zip}}</td-c></template>
          <template v-if="pref">
            <td-c @click.native='linkAppointment(list)'>
              <template v-if="list.pref === 0">未選択</template>
              <template v-if="list.pref === 1">北海道</template>
              <template v-if="list.pref === 2">青森県</template>
              <template v-if="list.pref === 3">秋田県</template>
              <template v-if="list.pref === 4">岩手県</template>
              <template v-if="list.pref === 5">山形県</template>
              <template v-if="list.pref === 6">宮城県</template>
              <template v-if="list.pref === 7">福島県</template>
              <template v-if="list.pref === 8">栃木県</template>
              <template v-if="list.pref === 9">山梨県</template>
              <template v-if="list.pref === 10">群馬県</template>
              <template v-if="list.pref === 11">茨城県</template>
              <template v-if="list.pref === 12">千葉県</template>
              <template v-if="list.pref === 13">埼玉県</template>
              <template v-if="list.pref === 14">東京都</template>
              <template v-if="list.pref === 15">神奈川県</template>
              <template v-if="list.pref === 16">静岡県</template>
              <template v-if="list.pref === 17">長野県</template>
              <template v-if="list.pref === 18">愛知県</template>
              <template v-if="list.pref === 19">岐阜県</template>
              <template v-if="list.pref === 20">新潟県</template>
              <template v-if="list.pref === 21">富山県</template>
              <template v-if="list.pref === 22">石川県</template>
              <template v-if="list.pref === 23">福井県</template>
              <template v-if="list.pref === 24">滋賀県</template>
              <template v-if="list.pref === 25">京都府</template>
              <template v-if="list.pref === 26">三重県</template>
              <template v-if="list.pref === 27">和歌山県</template>
              <template v-if="list.pref === 28">奈良県</template>
              <template v-if="list.pref === 29">大阪府</template>
              <template v-if="list.pref === 30">兵庫県</template>
              <template v-if="list.pref === 31">鳥取県</template>
              <template v-if="list.pref === 32">島根県</template>
              <template v-if="list.pref === 33">岡山県</template>
              <template v-if="list.pref === 34">広島県</template>
              <template v-if="list.pref === 35">山口県</template>
              <template v-if="list.pref === 36">高知県</template>
              <template v-if="list.pref === 37">徳島県</template>
              <template v-if="list.pref === 38">香川県</template>
              <template v-if="list.pref === 39">愛媛県</template>
              <template v-if="list.pref === 40">福岡県</template>
              <template v-if="list.pref === 41">佐賀県</template>
              <template v-if="list.pref === 42">長崎県</template>
              <template v-if="list.pref === 43">熊本県</template>
              <template v-if="list.pref === 44">宮崎県</template>
              <template v-if="list.pref === 45">大分県</template>
              <template v-if="list.pref === 46">鹿児島県</template>
              <template v-if="list.pref === 47">沖縄県</template>
            </td-c>
          </template>
          <template v-if="address"><td-c @click.native='linkAppointment(list)'><div class="fix">{{list.address1}} {{list.address2}}</div></td-c></template>
          <template v-if="tel1"><td-c @click.native='linkAppointment(list)'>{{list.tel1}}</td-c></template>
          <template v-if="tel2"><td-c @click.native='linkAppointment(list)'>{{list.tel2}}</td-c></template>
          <template v-if="preferred_contact">
            <td-c v-if="list.preferred_contact === 0"></td-c>
            <td-c v-if="list.preferred_contact === 1">携帯</td-c>
            <td-c v-if="list.preferred_contact === 2">自宅</td-c>
          </template>
          <template v-if="contact_timezone"><td-c>{{list.contact_timezone}}</td-c></template>
          <template v-if="fax"><td-c @click.native='linkAppointment(list)'>{{list.fax}}</td-c></template>
          <template v-if="mail"><td-c @click.native='linkAppointment(list)'>{{list.mail}}</td-c></template>
          <template v-if="contact_date"><td-c @click.native='linkAppointment(list)'>{{list.contact_date}}</td-c></template>
          <template v-if="support">
            <td-c @click.native='linkAppointment(list)' v-if="list.support === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.support === 1">獲得</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.support === 2">逃し</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.support === 3">断り</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.support === 4">APCXL</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.support === 5">ツブレ</td-c>
          </template>
          <template v-if="missing_detail">
            <td-c @click.native='linkAppointment(list)' v-if="list.missing_detail === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.missing_detail === 1">エリア外</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.missing_detail === 2">子嫌</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.missing_detail === 3">予算</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.missing_detail === 4">バッティング</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.missing_detail === 5">短期希望</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.missing_detail === 6">指導範囲外</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.missing_detail === 7">不通</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.missing_detail === 8">話し込めず</td-c>
          </template>
          <template v-if="contact_later">
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_later === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_later === 1">OK</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_later === 2">NG</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_later === 3">未連絡</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_later === 4">再連絡</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_later === 5">先探し</td-c>
          </template>
          <template v-if="next_contact_date"><td-c @click.native='linkAppointment(list)'>{{list.next_contact_date}}</td-c></template>
          <template v-if="result">
            <td-c @click.native='linkAppointment(list)' v-if="list.result === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.result === 1">契約</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.result === 2">のみ</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.result === 3">保留</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.result === 4">ツブレ</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.result === 5">ズレ</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.result === 6">再営業</td-c>
          </template>
          <template v-if="acquisition_date"><td-c @click.native='linkAppointment(list)'>{{list.acquisition_date}}</td-c></template>
          <template v-if="acquisition_date"><td-c @click.native='linkAppointment(list)'></td-c></template>
          <template v-if="ap_type">
            <td-c @click.native='linkAppointment(list)' v-if="list.ap_type === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.ap_type === 1">体験希望</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.ap_type === 2">資料請求</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.ap_type === 3">問い合わせ</td-c>
          </template>
          <template v-if="medium1">
            <td-c @click.native='linkAppointment(list)' v-if="list.medium1 === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium1 === 1">DM</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium1 === 2">貼紙</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium1 === 3">HP</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium1 === 4">紹介</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium1 === 5">TEL注</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium1 === 6">TA</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium1 === 7">その他</td-c>
          </template>
          <template v-if="medium2">
            <td-c @click.native='linkAppointment(list)' v-if="list.medium2 === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium2 === 1">DM</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium2 === 2">貼紙</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium2 === 3">HP</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium2 === 4">紹介</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium2 === 5">TEL注</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium2 === 6">TA</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium2 === 7">その他</td-c>
          </template>
          <template v-if="medium3">
            <td-c @click.native='linkAppointment(list)' v-if="list.medium3 === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium3 === 1">DM</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium3 === 2">貼紙</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium3 === 3">HP</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium3 === 4">紹介</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium3 === 5">TEL注</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium3 === 6">TA</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.medium3 === 7">その他</td-c>
          </template>
          <template v-if="hp_type">
            <td-c @click.native='linkAppointment(list)' v-if="list.hp_type === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.hp_type === 1">自社</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.hp_type === 2">リスティング</td-c>
          </template>
          <template v-if="office_id">
            <td-c @click.native='linkAppointment(list)' v-if="list.office_id === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.office_id === 1">仙台</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.office_id === 2">札幌</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.office_id === 3">名古屋</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.office_id === 4">福岡</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.office_id === 5">新宿</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.office_id === 6">大宮</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.office_id === 7">高松</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.office_id === 8">高崎</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.office_id === 9">東京</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.office_id === 10">大阪</td-c>
          </template>
          <template v-if="gender">
            <td-c @click.native='linkAppointment(list)' v-if="list.gender === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.gender === 1">男</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.gender === 2">女</td-c>
          </template>
          <template v-if="school_type">
            <td-c @click.native='linkAppointment(list)' v-if="list.school_type === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.school_type === 1">公立</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.school_type === 2">国立</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.school_type === 3">私立</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.school_type === 4">その他</td-c>
          </template>
          <template v-if="school_name"><td-c @click.native='linkAppointment(list)'>{{list.school_name}}</td-c></template>
          <template v-if="school_stage">
            <td-c @click.native='linkAppointment(list)' v-if="list.school_stage === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.school_stage === 1">小学</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.school_stage === 2">中学</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.school_stage === 3">高校</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.school_stage === 4">幼稚園</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.school_stage === 5">その他</td-c>
          </template>
          <template v-if="grade">
            <td-c @click.native='linkAppointment(list)' v-if="list.grade === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.grade === 1">1</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.grade === 2">2</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.grade === 3">3</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.grade === 4">4</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.grade === 5">5</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.grade === 6">6</td-c>
          </template>
          <template v-if="memo"><td-c @click.native='linkAppointment(list)'>{{list.memo}}</td-c></template>
          <template v-if="dm"><td-c @click.native='linkAppointment(list)'>{{list.dm.slice(0, 7)}}</td-c></template>
          <template v-if="shop_type">
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 1">スーパー</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 2">ドラッグストア</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 3">調剤薬局</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 4">100円ショップ</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 5">郵便局</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 6">銀行</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 7">ディスカウントストア</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 8">パン屋</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 9">病院</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 10">コンビニ</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 11">ラーメン・そば系</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 12">その他飲食店</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 13">弁当屋</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 14">携帯ショップ</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 15">クリーニング屋</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 16">本屋</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 17">個人商店</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 18">娯楽施設</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 19">A</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 20">B</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 21">C</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 22">D</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 23">E</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 24">F</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 25">G</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 26">H</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 27">I</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 28">J</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 29">K</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.shop_type === 30">L</td-c>
          </template>
          <template v-if="shop_name"><td-c @click.native='linkAppointment(list)'>{{list.shop_name}}</td-c></template>
          <template v-if="contact_method">
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_method === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_method === 1">TEL</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_method === 2">PCメール</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_method === 3">スマホメール</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_method === 4">その他</td-c>
          </template>
          <template v-if="hp_browse">
            <td-c @click.native='linkAppointment(list)' v-if="list.hp_browse === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.hp_browse === 1">PC</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.hp_browse === 2">SmartPhone</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.hp_browse === 3">両方</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.hp_browse === 4">非閲覧</td-c>
          </template>
          <template v-if="visit_date"><td-c @click.native='linkAppointment(list)'>{{list.visit_date}}</td-c></template>
          <template v-if="visit_time"><td-c @click.native='linkAppointment(list)'>{{list.visit_time}}</td-c></template>
          <template v-if="next_visit_date"><td-c @click.native='linkAppointment(list)'>{{list.next_visit_date}}</td-c></template>
          <template v-if="next_visit_time"><td-c @click.native='linkAppointment(list)'>{{list.next_visit_time}}</td-c></template>
          <template v-if="person"><td-c @click.native='linkAppointment(list)'>{{list.person}}</td-c></template>
          <template v-if="note"><td-c @click.native='linkAppointment(list)'>{{list.note}}</td-c></template>
          <template v-if="contact_person">
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_person === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_person === 1">母</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_person === 2">父</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_person === 3">祖母</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_person === 4">祖父</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_person === 5">本人</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_person === 6">伯母</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.contact_person === 7">伯父</td-c>
          </template>
          <template v-if="parking">
            <td-c @click.native='linkAppointment(list)' v-if="list.parking === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.parking === 1">有</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.parking === 2">無</td-c>
          </template>
          <template v-if="parking_note"><td-c @click.native='linkAppointment(list)'>{{list.parking_note}}</td-c></template>
          <template v-if="sub_f_name"><td-c @click.native='linkAppointment(list)'>{{list.sub_f_name}}</td-c></template>
          <template v-if="sub_l_name"><td-c @click.native='linkAppointment(list)'>{{list.sub_l_name}}</td-c></template>
          <template v-if="sub_f_name_kana"><td-c @click.native='linkAppointment(list)'>{{list.sub_f_name_kana}}</td-c></template>
          <template v-if="sub_l_name_kana"><td-c @click.native='linkAppointment(list)'>{{list.sub_l_name_kana}}</td-c></template>
          <template v-if="sub_gender">
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_gender === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_gender === 1">男</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_gender === 2">女</td-c>
          </template>
          <template v-if="sub_school_type">
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_school_type === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_school_type === 1">公立</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_school_type === 2">国立</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_school_type === 3">私立</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_school_type === 4">その他</td-c>
          </template>
          <template v-if="sub_school_name"><td-c @click.native='linkAppointment(list)'>{{list.sub_school_name}}</td-c></template>
          <template v-if="sub_school_stage">
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_school_stage === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_school_stage === 1">小学</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_school_stage === 2">中学</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_school_stage === 3">高校</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_school_stage === 4">幼稚園</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_school_stage === 5">その他</td-c>
          </template>
          <template v-if="sub_grade">
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_grade === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_grade === 1">1</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_grade === 2">2</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_grade === 3">3</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_grade === 4">4</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_grade === 5">5</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_grade === 6">6</td-c>
          </template>
          <template v-if="achievement"><td-c @click.native='linkAppointment(list)'>{{list.achievement}}</td-c></template>
          <template v-if="learning"><td-c @click.native='linkAppointment(list)'>{{list.learning}}</td-c></template>
          <template v-if="learning_start_period"><td-c @click.native='linkAppointment(list)'>{{list.learning_start_period}}</td-c></template>
          <template v-if="learning_nervous"><td-c @click.native='linkAppointment(list)'>{{list.learning_nervous}}</td-c></template>
          <template v-if="learning_result">
            <td-c @click.native='linkAppointment(list)' v-if="list.learning_result === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.learning_result === 1">上がった</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.learning_result === 2">下がった</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.learning_result === 3">変わらない</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.learning_result === 4">わからない</td-c>
          </template>
          <template v-if="learning_continuation">
            <td-c @click.native='linkAppointment(list)' v-if="list.learning_continuation === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.learning_continuation === 1">継続する</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.learning_continuation === 2">継続しない</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.learning_continuation === 3">わからない</td-c>
          </template>
          <template v-if="sub_achievement"><td-c @click.native='linkAppointment(list)'>{{list.sub_achievement}}</td-c></template>
          <template v-if="sub_learning"><td-c @click.native='linkAppointment(list)'>{{list.sub_learning}}</td-c></template>
          <template v-if="sub_learning_start_period"><td-c @click.native='linkAppointment(list)'>{{list.sub_learning_start_period}}</td-c></template>
          <template v-if="sub_learning_nervous"><td-c @click.native='linkAppointment(list)'>{{list.sub_learning_nervous}}</td-c></template>
          <template v-if="sub_learning_result">
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_learning_result === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_learning_result === 1">上がった</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_learning_result === 2">下がった</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_learning_result === 3">変わらない</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_learning_result === 4">わからない</td-c>
          </template>
          <template v-if="sub_learning_continuation">
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_learning_continuation === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_learning_continuation === 1">継続する</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_learning_continuation === 2">継続しない</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.sub_learning_continuation === 3">わからない</td-c>
          </template>
          <template v-if="attended"><td-c>{{list.attended}}</td-c></template>
          <template v-if="fathers_involvement">
            <td-c @click.native='linkAppointment(list)' v-if="list.fathers_involvement === 0">未選択</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.fathers_involvement === 1">有</td-c>
            <td-c @click.native='linkAppointment(list)' v-if="list.fathers_involvement === 2">無</td-c>
          </template>
          <template v-if="notices">
            <td-c @click.native='linkAppointment(list)'>{{list.notices}}</td-c>
          </template>
          <template v-if="transmission_item_company">
            <td-c v-if="list.transmission_item_company === 0"></td-c>
            <td-c v-if="list.transmission_item_company === 1">○</td-c>
          </template>
          <template v-if="transmission_item_course">
            <td-c v-if="list.transmission_item_course === 0"></td-c>
            <td-c v-if="list.transmission_item_course === 1">○</td-c>
          </template>
          <template v-if="transmission_item_visitor">
            <td-c v-if="list.transmission_item_visitor === 0"></td-c>
            <td-c v-if="list.transmission_item_visitor === 1">○</td-c>
          </template>
          <template v-if="transmission_item_purpose">
            <td-c v-if="list.transmission_item_purpose === 0"></td-c>
            <td-c v-if="list.transmission_item_purpose === 1">○</td-c>
          </template>
          <template v-if="transmission_item_requiredtime">
            <td-c v-if="list.transmission_item_requiredtime === 0"></td-c>
            <td-c v-if="list.transmission_item_requiredtime === 1">○</td-c>
          </template>
          <template v-if="created_at"><td-c @click.native='linkAppointment(list)'>{{list.created_at.substring(0, 10)}}</td-c></template>
        </tr-c>
      </table-c>
    </div>
  </div>
</template>

<script>
import { getAPIURL } from '@/store/getters.js'
import config from '@/settings/config.js'
const url = getAPIURL() + '/api/v1/appointments/search?limit=' + config.LIMIT
import moment from 'moment'

// var TIMER = null
var obj = {
  timer: null,
  TIMER: null,
  COUNT: 1,
  offset: config.LIMIT,
  max: config.LIMIT + 1,
  url: url,
  searchUrl: url,
  pageName: 'appointment',
  pageNames: 'appointments'
}

let _ = window._
export default {
  computed: {
    obj () {
      return obj
    },

    max () {
      return this.$store.getters.max
    },

    stateSelect () {
      return this.$store.getters['appointments/state']
    },

    supportSelect () {
      return this.$store.getters['appointments/support']
    },

    missing_detailSelect () {
      return this.$store.getters['appointments/missing_detail']
    },

    contact_laterSelect () {
      return this.$store.getters['appointments/contact_later']
    },

    resultSelect () {
      return this.$store.getters['appointments/result']
    },

    ap_typeSelect () {
      return this.$store.getters['appointments/ap_type']
    },

    mediumSelect () {
      return this.$store.getters['appointments/medium']
    },

    shop_typeSelect () {
      return this.$store.getters['appointments/shop_type']
    },

    hp_typeSelect () {
      return this.$store.getters['appointments/hp_type']
    },

    hp_browseSelect () {
      return this.$store.getters['appointments/hp_browse']
    },

    genderSelect () {
      return this.$store.getters['appointments/gender']
    },

    school_typeSelect () {
      return this.$store.getters['appointments/school_type']
    },

    school_stageSelect () {
      return this.$store.getters['appointments/school_stage']
    },

    gradeSelect () {
      return this.$store.getters['appointments/grade']
    },

    contact_methodSelect () {
      return this.$store.getters['appointments/contact_method']
    },

    contact_personSelect () {
      return this.$store.getters['appointments/contact_person']
    },

    parkingSelect () {
      return this.$store.getters['appointments/parking']
    },

    learning_resultSelect () {
      return this.$store.getters['appointments/learning_result']
    },

    learning_continuationSelect () {
      return this.$store.getters['appointments/learning_continuation']
    },

    fathers_involvementSelect () {
      return this.$store.getters['appointments/fathers_involvement']
    },

    sending_methodSelect () {
      return this.$store.getters['appointments/sending_method']
    },

    preferred_contactSelect () {
      return this.$store.getters['appointments/preferred_contact']
    },

    maruSelect () {
      return this.$store.getters['appointments/maru']
    },

    appointments () {
      return this.$store.getters.appointments
    },

    users () {
      return this.$store.getters.users
    },

    offices () {
      return this.$store.getters.offices.reverse()
    },

    prefs () {
      return this.$store.getters.prefs.reverse()
    },

    // order By
    orderedAppointments () {
      if (this.sortState === '' || this.sortState === '降順') {
        return _.orderBy(this.appointments, this.sortColumn).reverse()
      } else if (this.sortState === '昇順') {
        return _.orderBy(this.appointments, this.sortColumn)
      }
    },

    // map
    mapAppointments () {
      let self = this
      return self.orderedAppointments.map(function (appointment) {
        appointment.sending_check = self.calcSending_check(appointment.sending_check)
        appointment.confirm_check = self.calcConfirm_check(appointment.confirm_check)
        return appointment
      })
    }
  },
  directives: {
    focus: {
      inserted: function (el, binding) {
        el.focus()
        // console.log(el)
        // console.log(binding)
      }
    }
  },
  data () {
    return {
      column: false,
      sortState: '降順',
      sortColumn: 'id',
      sending_check: true,
      sending_products: true,
      sending_method: true,
      sending_date: true,
      sending_time: true,
      confirm_check: true,

      id: false,
      family_id: false,
      user_id: false,
      state: true,
      name: true,
      kana: true,
      zip: false,
      pref: true,
      address: true,
      tel1: true,
      tel2: false,
      preferred_contact: true,
      contact_timezone: true,
      fax: false,
      mail: false,
      contact_date: false,
      support: false,
      missing_detail: false,
      contact_later: false,
      next_contact_date: false,
      result: false,
      acquisition_date: false,
      ap_type: false,
      medium1: false,
      medium2: false,
      medium3: false,
      hp_type: false,
      office_id: false,
      gender: false,
      school_type: false,
      school_name: false,
      school_stage: false,
      grade: false,
      memo: false,
      dm: false,
      shop_type: false,
      shop_name: false,
      contact_method: false,
      hp_browse: false,
      visit_date: true,
      visit_time: true,
      next_visit_date: true,
      next_visit_time: true,
      person: false,
      note: false,
      contact_person: false,
      parking: false,
      parking_note: false,
      sub_f_name: false,
      sub_l_name: false,
      sub_f_name_kana: false,
      sub_l_name_kana: false,
      sub_gender: false,
      sub_school_type: false,
      sub_school_name: false,
      sub_school_stage: false,
      sub_grade: false,
      achievement: false,
      learning: false,
      learning_start_period: false,
      learning_nervous: false,
      learning_result: false,
      learning_continuation: false,
      sub_achievement: false,
      sub_learning: false,
      sub_learning_start_period: false,
      sub_learning_nervous: false,
      sub_learning_result: false,
      sub_learning_continuation: false,
      attended: false,
      fathers_involvement: false,
      notices: false,
      transmission_item_company: false,
      transmission_item_course: false,
      transmission_item_visitor: false,
      transmission_item_purpose: false,
      transmission_item_requiredtime: false,
      created_at: false,

      search: {
        sending_check: '',
        sending_products: '',
        sending_method: '',
        sending_date: '',
        sending_time: '',
        confirm_check: '',
        id: '',
        family_id: '',
        user_id: '',
        state: '',
        name: '',
        kana: '',
        zip: '',
        pref: '',
        address: '',
        tel1: '',
        tel2: '',
        preferred_contact: '',
        contact_timezone: '',
        fax: '',
        mail: '',
        contact_date: '',
        support: '',
        missing_detail: '',
        contact_later: '',
        next_contact_date: '',
        result: '',
        acquisition_date: [],
        ap_type: '',
        medium1: '',
        medium2: '',
        medium3: '',
        hp_type: '',
        office_id: '',
        gender: '',
        school_type: '',
        school_name: '',
        school_stage: '',
        grade: '',
        memo: '',
        dm: '',
        shop_type: '',
        shop_name: '',
        contact_method: '',
        hp_browse: '',
        visit_date: '',
        visit_time: '',
        next_visit_date: '',
        next_visit_time: '',
        person: '',
        note: '',
        contact_person: '',
        parking: '',
        parking_note: '',
        sub_f_name: '',
        sub_l_name: '',
        sub_f_name_kana: '',
        sub_l_name_kana: '',
        sub_gender: '',
        sub_school_type: '',
        sub_school_name: '',
        sub_school_stage: '',
        sub_grade: '',
        achievement: '',
        learning: '',
        learning_start_period: '',
        learning_nervous: '',
        learning_result: '',
        learning_continuation: '',
        sub_achievement: '',
        sub_learning: '',
        sub_learning_start_period: '',
        sub_learning_nervous: '',
        sub_learning_result: '',
        sub_learning_continuation: '',
        attended: '',
        fathers_involvement: '',
        notices: '',
        transmission_item_company: '',
        transmission_item_course: '',
        transmission_item_visitor: '',
        transmission_item_purpose: '',
        transmission_item_requiredtime: '',
        created_at: '',

        not_sending_check: '',
        not_sending_products: '',
        not_sending_method: '',
        not_sending_date: '',
        not_sending_time: '',
        not_confirm_check: '',
        not_id: '',
        not_family_id: '',
        not_user_id: '',
        not_state: '',
        not_name: '',
        not_kana: '',
        not_zip: '',
        not_pref: '',
        not_address: '',
        not_tel1: '',
        not_tel2: '',
        not_preferred_contact: '',
        not_contact_timezone: '',
        not_fax: '',
        not_mail: '',
        not_contact_date: '',
        not_support: '',
        not_missing_detail: '',
        not_contact_later: '',
        not_next_contact_date: '',
        not_result: '',
        not_acquisition_date: [],
        not_ap_type: '',
        not_medium1: '',
        not_medium2: '',
        not_medium3: '',
        not_hp_type: '',
        not_office_id: '',
        not_gender: '',
        not_school_type: '',
        not_school_name: '',
        not_school_stage: '',
        not_grade: '',
        not_memo: '',
        not_dm: '',
        not_shop_type: '',
        not_shop_name: '',
        not_contact_method: '',
        not_hp_browse: '',
        not_visit_date: '',
        not_person: '',
        not_note: '',
        not_contact_person: '',
        not_parking: '',
        not_parking_note: '',
        not_sub_f_name: '',
        not_sub_l_name: '',
        not_sub_f_name_kana: '',
        not_sub_l_name_kana: '',
        not_sub_gender: '',
        not_sub_school_type: '',
        not_sub_school_name: '',
        not_sub_school_stage: '',
        not_sub_grade: '',
        not_achievement: '',
        not_learning: '',
        not_learning_start_period: '',
        not_learning_nervous: '',
        not_learning_result: '',
        not_learning_continuation: '',
        not_sub_achievement: '',
        not_sub_learning: '',
        not_sub_learning_start_period: '',
        not_sub_learning_nervous: '',
        not_sub_learning_result: '',
        not_sub_learning_continuation: '',
        not_attended: '',
        not_fathers_involvement: '',
        not_notices: '',
        not_transmission_item_company: '',
        not_transmission_item_course: '',
        not_transmission_item_visitor: '',
        not_transmission_item_purpose: '',
        not_transmission_item_requiredtime: '',
        not_created_at: ''
      },

      watch: {
        sending_check: '',
        sending_method: '',
        confirm_check: '',
        user_id: '',
        state: '',
        support: '',
        missing_detail: '',
        contact_later: '',
        result: '',
        ap_type: '',
        medium1: '',
        medium2: '',
        medium3: '',
        hp_type: '',
        office_id: '',
        pref: '',
        preferred_contact: '',
        gender: '',
        school_type: '',
        school_stage: '',
        grade: '',
        shop_type: '',
        contact_method: '',
        hp_browse: '',
        contact_person: '',
        parking: '',
        sub_gender: '',
        sub_school_type: '',
        sub_school_stage: '',
        sub_grade: '',
        learning_result: '',
        learning_continuation: '',
        sub_learning_result: '',
        sub_learning_continuation: '',
        attended: '',
        fathers_involvement: '',
        notices: '',
        transmission_item_company: '',
        transmission_item_course: '',
        transmission_item_visitor: '',
        transmission_item_purpose: '',
        transmission_item_requiredtime: '',

        not_sending_check: '',
        not_sending_method: '',
        not_confirm_check: '',
        not_user_id: '',
        not_state: '',
        not_support: '',
        not_missing_detail: '',
        not_contact_later: '',
        not_result: '',
        not_ap_type: '',
        not_medium1: '',
        not_medium2: '',
        not_medium3: '',
        not_hp_type: '',
        not_office_id: '',
        not_pref: '',
        not_preferred_contact: '',
        not_gender: '',
        not_school_type: '',
        not_school_stage: '',
        not_grade: '',
        not_shop_type: '',
        not_contact_method: '',
        not_hp_browse: '',
        not_contact_person: '',
        not_parking: '',
        not_sub_gender: '',
        not_sub_school_type: '',
        not_sub_school_stage: '',
        not_sub_grade: '',
        not_learning_result: '',
        not_learning_continuation: '',
        not_sub_learning_result: '',
        not_sub_learning_continuation: '',
        not_attended: '',
        not_fathers_involvement: '',
        not_notices: '',
        not_transmission_item_company: '',
        not_transmission_item_course: '',
        not_transmission_item_visitor: '',
        not_transmission_item_purpose: '',
        not_transmission_item_requiredtime: ''
      },

      confirm_checkSelect: [
        { name: '', value: 0 },
        { name: '○', value: 1 }
      ]
    }
  },

  watch: {
    'watch.sending_check': function (now, old) {
      if (now) {
        this.search.sending_check = now.value
      } else {
        this.search.sending_check = ''
      }
    },

    'watch.not_sending_check': function (now, old) {
      if (now) {
        this.search.not_sending_check = now.value
      } else {
        this.search.not_sending_check = ''
      }
    },

    'watch.sending_method': function (now, old) {
      if (now) {
        this.search.sending_method = now.value
      } else {
        this.search.sending_method = ''
      }
    },

    'watch.not_sending_method': function (now, old) {
      if (now) {
        this.search.not_sending_method = now.value
      } else {
        this.search.not_sending_method = ''
      }
    },

    'watch.confirm_check': function (now, old) {
      if (now) {
        this.search.confirm_check = now.value
      } else {
        this.search.confirm_check = ''
      }
    },

    'watch.not_confirm_check': function (now, old) {
      if (now) {
        this.search.not_confirm_check = now.value
      } else {
        this.search.not_confirm_check = ''
      }
    },

    'watch.user_id': function (now, old) {
      if (now) {
        this.search.user_id = now.id
      } else {
        this.search.user_id = ''
      }
    },

    'watch.not_user_id': function (now, old) {
      if (now) {
        this.search.not_user_id = now.id
      } else {
        this.search.not_user_id = ''
      }
    },

    'watch.state': function (now, old) {
      if (now) {
        this.search.state = now.value
      } else {
        this.search.state = ''
      }
    },

    'watch.not_state': function (now, old) {
      if (now) {
        this.search.not_state = now.value
      } else {
        this.search.not_state = ''
      }
    },

    'watch.support': function (now, old) {
      if (now) {
        this.search.support = now.value
      } else {
        this.search.support = ''
      }
    },

    'watch.not_support': function (now, old) {
      if (now) {
        this.search.not_support = now.value
      } else {
        this.search.not_support = ''
      }
    },

    'watch.missing_detail': function (now, old) {
      if (now) {
        this.search.missing_detail = now.value
      } else {
        this.search.missing_detail = ''
      }
    },

    'watch.not_missing_detail': function (now, old) {
      if (now) {
        this.search.not_missing_detail = now.value
      } else {
        this.search.not_missing_detail = ''
      }
    },

    'watch.contact_later': function (now, old) {
      if (now) {
        this.search.contact_later = now.value
      } else {
        this.search.contact_later = ''
      }
    },

    'watch.not_contact_later': function (now, old) {
      if (now) {
        this.search.not_contact_later = now.value
      } else {
        this.search.not_contact_later = ''
      }
    },

    'watch.result': function (now, old) {
      if (now) {
        this.search.result = now.value
      } else {
        this.search.result = ''
      }
    },

    'watch.not_result': function (now, old) {
      if (now) {
        this.search.not_result = now.value
      } else {
        this.search.not_result = ''
      }
    },

    'watch.ap_type': function (now, old) {
      if (now) {
        this.search.ap_type = now.value
      } else {
        this.search.ap_type = ''
      }
    },

    'watch.not_ap_type': function (now, old) {
      if (now) {
        this.search.not_ap_type = now.value
      } else {
        this.search.not_ap_type = ''
      }
    },

    'watch.medium1': function (now, old) {
      if (now) {
        this.search.medium1 = now.value
      } else {
        this.search.medium1 = ''
      }
    },

    'watch.not_medium1': function (now, old) {
      if (now) {
        this.search.not_medium1 = now.value
      } else {
        this.search.not_medium1 = ''
      }
    },

    'watch.medium2': function (now, old) {
      if (now) {
        this.search.medium2 = now.value
      } else {
        this.search.medium2 = ''
      }
    },

    'watch.not_medium2': function (now, old) {
      if (now) {
        this.search.not_medium2 = now.value
      } else {
        this.search.not_medium2 = ''
      }
    },

    'watch.medium3': function (now, old) {
      if (now) {
        this.search.medium3 = now.value
      } else {
        this.search.medium3 = ''
      }
    },

    'watch.not_medium3': function (now, old) {
      if (now) {
        this.search.not_medium3 = now.value
      } else {
        this.search.not_medium3 = ''
      }
    },

    'watch.hp_type': function (now, old) {
      if (now) {
        this.search.hp_type = now.value
      } else {
        this.search.hp_type = ''
      }
    },

    'watch.not_hp_type': function (now, old) {
      if (now) {
        this.search.not_hp_type = now.value
      } else {
        this.search.not_hp_type = ''
      }
    },

    'watch.office_id': function (now, old) {
      if (now) {
        this.search.office_id = now.id
      } else {
        this.search.office_id = ''
      }
    },

    'watch.not_office_id': function (now, old) {
      if (now) {
        this.search.not_office_id = now.id
      } else {
        this.search.not_office_id = ''
      }
    },

    'watch.pref': function (now, old) {
      if (now) {
        this.search.pref = now.value
      } else {
        this.search.pref = ''
      }
    },

    'watch.not_pref': function (now, old) {
      if (now) {
        this.search.not_pref = now.value
      } else {
        this.search.not_pref = ''
      }
    },

    'watch.preferred_contact': function (now, old) {
      if (now) {
        this.search.preferred_contact = now.value
      } else {
        this.search.preferred_contact = ''
      }
    },

    'watch.not_preferred_contact': function (now, old) {
      if (now) {
        this.search.not_preferred_contact = now.value
      } else {
        this.search.not_preferred_contact = ''
      }
    },

    'watch.gender': function (now, old) {
      if (now) {
        this.search.gender = now.value
      } else {
        this.search.gender = ''
      }
    },

    'watch.not_gender': function (now, old) {
      if (now) {
        this.search.not_gender = now.value
      } else {
        this.search.not_gender = ''
      }
    },

    'watch.school_type': function (now, old) {
      if (now) {
        this.search.school_type = now.value
      } else {
        this.search.school_type = ''
      }
    },

    'watch.not_school_type': function (now, old) {
      if (now) {
        this.search.not_school_type = now.value
      } else {
        this.search.not_school_type = ''
      }
    },

    'watch.school_stage': function (now, old) {
      if (now) {
        this.search.school_stage = now.value
      } else {
        this.search.school_stage = ''
      }
    },

    'watch.not_school_stage': function (now, old) {
      if (now) {
        this.search.not_school_stage = now.value
      } else {
        this.search.not_school_stage = ''
      }
    },

    'watch.grade': function (now, old) {
      if (now) {
        this.search.grade = now.value
      } else {
        this.search.grade = ''
      }
    },

    'watch.not_grade': function (now, old) {
      if (now) {
        this.search.not_grade = now.value
      } else {
        this.search.not_grade = ''
      }
    },

    'watch.shop_type': function (now, old) {
      if (now) {
        this.search.shop_type = now.value
      } else {
        this.search.shop_type = ''
      }
    },

    'watch.not_shop_type': function (now, old) {
      if (now) {
        this.search.not_shop_type = now.value
      } else {
        this.search.not_shop_type = ''
      }
    },

    'watch.contact_method': function (now, old) {
      if (now) {
        this.search.contact_method = now.value
      } else {
        this.search.contact_method = ''
      }
    },

    'watch.not_contact_method': function (now, old) {
      if (now) {
        this.search.not_contact_method = now.value
      } else {
        this.search.not_contact_method = ''
      }
    },

    'watch.hp_browse': function (now, old) {
      if (now) {
        this.search.hp_browse = now.value
      } else {
        this.search.hp_browse = ''
      }
    },

    'watch.not_hp_browse': function (now, old) {
      if (now) {
        this.search.not_hp_browse = now.value
      } else {
        this.search.not_hp_browse = ''
      }
    },

    'watch.contact_person': function (now, old) {
      if (now) {
        this.search.contact_person = now.value
      } else {
        this.search.contact_person = ''
      }
    },

    'watch.not_contact_person': function (now, old) {
      if (now) {
        this.search.not_hp_browse = now.value
      } else {
        this.search.not_hp_browse = ''
      }
    },

    'watch.parking': function (now, old) {
      if (now) {
        this.search.parking = now.value
      } else {
        this.search.parking = ''
      }
    },

    'watch.not_parking': function (now, old) {
      if (now) {
        this.search.not_parking = now.value
      } else {
        this.search.not_parking = ''
      }
    },

    'watch.sub_gender': function (now, old) {
      if (now) {
        this.search.sub_gender = now.value
      } else {
        this.search.sub_gender = ''
      }
    },

    'watch.not_sub_gender': function (now, old) {
      if (now) {
        this.search.not_sub_gender = now.value
      } else {
        this.search.not_sub_gender = ''
      }
    },

    'watch.sub_school_type': function (now, old) {
      if (now) {
        this.search.sub_school_type = now.value
      } else {
        this.search.sub_school_type = ''
      }
    },

    'watch.not_sub_school_type': function (now, old) {
      if (now) {
        this.search.not_sub_school_type = now.value
      } else {
        this.search.not_sub_school_type = ''
      }
    },

    'watch.sub_school_stage': function (now, old) {
      if (now) {
        this.search.sub_school_stage = now.value
      } else {
        this.search.sub_school_stage = ''
      }
    },

    'watch.not_sub_school_stage': function (now, old) {
      if (now) {
        this.search.not_sub_school_stage = now.value
      } else {
        this.search.not_sub_school_stage = ''
      }
    },

    'watch.sub_grade': function (now, old) {
      if (now) {
        this.search.sub_grade = now.value
      } else {
        this.search.sub_grade = ''
      }
    },

    'watch.not_sub_grade': function (now, old) {
      if (now) {
        this.search.not_sub_grade = now.value
      } else {
        this.search.not_sub_grade = ''
      }
    },

    'watch.learning_result': function (now, old) {
      if (now) {
        this.search.learning_result = now.value
      } else {
        this.search.learning_result = ''
      }
    },

    'watch.not_learning_result': function (now, old) {
      if (now) {
        this.search.not_learning_result = now.value
      } else {
        this.search.not_learning_result = ''
      }
    },

    'watch.learning_continuation': function (now, old) {
      if (now) {
        this.search.learning_continuation = now.value
      } else {
        this.search.learning_continuation = ''
      }
    },

    'watch.not_learning_continuation': function (now, old) {
      if (now) {
        this.search.not_learning_continuation = now.value
      } else {
        this.search.not_learning_continuation = ''
      }
    },

    'watch.sub_learning_result': function (now, old) {
      if (now) {
        this.search.sub_learning_result = now.value
      } else {
        this.search.sub_learning_result = ''
      }
    },

    'watch.not_sub_learning_result': function (now, old) {
      if (now) {
        this.search.not_sub_learning_result = now.value
      } else {
        this.search.not_sub_learning_result = ''
      }
    },

    'watch.sub_learning_continuation': function (now, old) {
      if (now) {
        this.search.sub_learning_continuation = now.value
      } else {
        this.search.sub_learning_continuation = ''
      }
    },

    'watch.not_sub_learning_continuation': function (now, old) {
      if (now) {
        this.search.not_sub_learning_continuation = now.value
      } else {
        this.search.not_sub_learning_continuation = ''
      }
    },

    'watch.attended': function (now, old) {
      if (now) {
        this.search.attended = now.value
      } else {
        this.search.attended = ''
      }
    },

    'watch.not_attended': function (now, old) {
      if (now) {
        this.search.not_attended = now.value
      } else {
        this.search.not_attended = ''
      }
    },

    'watch.fathers_involvement': function (now, old) {
      if (now) {
        this.search.fathers_involvement = now.value
      } else {
        this.search.fathers_involvement = ''
      }
    },

    'watch.not_fathers_involvement': function (now, old) {
      if (now) {
        this.search.not_fathers_involvement = now.value
      } else {
        this.search.not_fathers_involvement = ''
      }
    },

    'watch.notices': function (now, old) {
      if (now) {
        this.search.notices = now.value
      } else {
        this.search.notices = ''
      }
    },

    'watch.not_notices': function (now, old) {
      if (now) {
        this.search.not_notices = now.value
      } else {
        this.search.not_notices = ''
      }
    },

    'watch.transmission_item_company': function (now, old) {
      if (now) {
        this.search.transmission_item_company = now.value
      } else {
        this.search.transmission_item_company = ''
      }
    },

    'watch.not_transmission_item_company': function (now, old) {
      if (now) {
        this.search.not_transmission_item_company = now.value
      } else {
        this.search.not_transmission_item_company = ''
      }
    },

    'watch.transmission_item_course': function (now, old) {
      if (now) {
        this.search.transmission_item_course = now.value
      } else {
        this.search.transmission_item_course = ''
      }
    },

    'watch.not_transmission_item_course': function (now, old) {
      if (now) {
        this.search.not_transmission_item_course = now.value
      } else {
        this.search.not_transmission_item_course = ''
      }
    },

    'watch.transmission_item_visitor': function (now, old) {
      if (now) {
        this.search.transmission_item_visitor = now.value
      } else {
        this.search.transmission_item_visitor = ''
      }
    },

    'watch.not_transmission_item_visitor': function (now, old) {
      if (now) {
        this.search.not_transmission_item_visitor = now.value
      } else {
        this.search.not_transmission_item_visitor = ''
      }
    },

    'watch.transmission_item_purpose': function (now, old) {
      if (now) {
        this.search.transmission_item_purpose = now.value
      } else {
        this.search.transmission_item_purpose = ''
      }
    },

    'watch.not_transmission_item_purpose': function (now, old) {
      if (now) {
        this.search.not_transmission_item_purpose = now.value
      } else {
        this.search.not_transmission_item_purpose = ''
      }
    },

    'watch.transmission_item_requiredtime': function (now, old) {
      if (now) {
        this.search.transmission_item_requiredtime = now.value
      } else {
        this.search.transmission_item_requiredtime = ''
      }
    },

    'watch.not_transmission_item_requiredtime': function (now, old) {
      if (now) {
        this.search.not_transmission_item_requiredtime = now.value
      } else {
        this.search.not_transmission_item_requiredtime = ''
      }
    }
  },
  methods: {
    btn1 () {
      this.support = true
      this.acquisition_date = true
      this.resetSearch()
      this.watch.not_sending_check = this.maruSelect.filter(maru => {
        return maru.value === 1
      })[0]
      this.search.sending_products = '体験案内 資料'
      this.search.acquisition_date[0] = moment().add('days', -3).format('YYYY-MM-DD')
      this.search.acquisition_date[1] = moment().add('days', -1).format('YYYY-MM-DD')
      this.searchTable()
    },

    btn2 () {
      this.resetSearch()
      this.search.visit_date = moment().add('days', 1).format('YYYY-MM-DD')
      this.searchTable()
    },

    btn3 () {
      this.resetSearch()
      this.search.next_visit_date = moment().add('days', 1).format('YYYY-MM-DD')
      this.searchTable()
    },

    calcSending_check (e) {
      if (toString.call(e) === '[object Number]') {
        let obj = this.maruSelect[e]
        return obj
      } else if (toString.call(e) === '[object Object]') {
        return e
      }
    },

    calcConfirm_check (e) {
      if (toString.call(e) === '[object Number]') {
        let obj = this.confirm_checkSelect[e]
        return obj
      } else if (toString.call(e) === '[object Object]') {
        return e
      }
    },

    patchConfirm (list) {
      this.$store.dispatch('patchConfirm', {
        list: list
      })
    },

    linkAppointment (list) {
      const arr = [
        'id',
        'family_id',
        'user_id',
        'state',
        'f_name',
        'l_kana',
        'f_name_kana',
        'l_kana_kana',
        'zip',
        'pref',
        'address1',
        'address2',
        'tel1',
        'tel2',
        'contact_date',
        'support',
        'missing_detail',
        'contact_later',
        'next_contact_date',
        'result',
        'acquisition_date',
        'ap_type',
        'medium1',
        'medium2',
        'medium3',
        'hp_type',
        'office_id',
        'gender',
        'school_type',
        'school_stage',
        'grade',
        'memo',
        'dm',
        'shop_type',
        'shop_name',
        'hp_browse',
        'visit_date',
        'visit_time',
        'next_visit_date',
        'next_visit_time',
        'note',
        'sending_products',
        'sending_method',
        'sending_date',
        'sending_time',
        'contact_person',
        'parking',
        'parking_note',
        'sub_f_name',
        'sub_l_name',
        'sub_f_name_kana',
        'sub_l_name_kana',
        'sub_grade',
        'sub_gender',
        'achievement',
        'learning',
        'learning_start_period',
        'learning_nervous',
        'learning_result',
        'learning_continuation',
        'sub_achievement',
        'sub_learning',
        'sub_learning_start_period',
        'sub_learning_nervous',
        'sub_learning_result',
        'sub_learning_continuation',
        'attended',
        'fathers_involvement',
        'notices',
        'created_at'
      ]
      arr.forEach((item) => {
        this.$store.state.item.appointment[item] = list[item]
      })
      this.$router.push({name: 'appointmentindex', params: { id: list.id }})
    },

    select (selectedOption, id) {
      // console.log(selectedOption)
    },

    switchV: function (col) {
      this[col] = !this[col]
    },

    reset () {
      this.id = false
      this.family_id = false
      this.user_id = false
      this.state = false
      this.name = false
      this.kana = false
      this.zip = false
      this.pref = false
      this.address = false
      this.tel1 = false
      this.tel2 = false
      this.preferred_contact = false
      this.contact_timezone = false
      this.fax = false
      this.mail = false
      this.contact_date = false
      this.support = false
      this.missing_detail = false
      this.contact_later = false
      this.next_contact_date = false
      this.result = false
      this.acquisition_date = false
      this.ap_type = false
      this.medium1 = false
      this.medium2 = false
      this.medium3 = false
      this.hp_type = false
      this.office_id = false
      this.gender = false
      this.school_type = false
      this.school_name = false
      this.school_stage = false
      this.grade = false
      this.memo = false
      this.dm = false
      this.shop_type = false
      this.shop_name = false
      this.contact_method = false
      this.hp_browse = false
      this.visit_date = false
      this.visit_time = false
      this.next_visit_date = false
      this.next_visit_time = false
      this.person = false
      this.note = false
      this.sending_products = false
      this.sending_method = false
      this.sending_date = false
      this.sending_time = false
      this.contact_person = false
      this.parking = false
      this.parking_note = false
      this.sub_f_name = false
      this.sub_l_name = false
      this.sub_f_name_kana = false
      this.sub_l_name_kana = false
      this.sub_gender = false
      this.sub_school_type = false
      this.sub_school_name = false
      this.sub_school_stage = false
      this.sub_grade = false
      this.achievement = false
      this.learning = false
      this.learning_start_period = false
      this.learning_nervous = false
      this.learning_result = false
      this.learning_continuation = false
      this.sub_achievement = false
      this.sub_learning = false
      this.sub_learning_start_period = false
      this.sub_learning_nervous = false
      this.sub_learning_result = false
      this.sub_learning_continuation = false
      this.attended = false
      this.fathers_involvement = false
      this.notices = false
      this.transmission_item_company = false
      this.transmission_item_course = false
      this.transmission_item_visitor = false
      this.transmission_item_purpose = false
      this.transmission_item_requiredtime = false
      this.created_at = false
    },

    all () {
      this.id = true
      this.family_id = true
      this.user_id = true
      this.state = true
      this.name = true
      this.kana = true
      this.zip = true
      this.pref = true
      this.address = true
      this.tel1 = true
      this.tel2 = true
      this.preferred_contact = true
      this.contact_timezone = true
      this.fax = true
      this.mail = true
      this.contact_date = true
      this.support = true
      this.missing_detail = true
      this.contact_later = true
      this.next_contact_date = true
      this.result = true
      this.acquisition_date = true
      this.ap_type = true
      this.medium1 = true
      this.medium2 = true
      this.medium3 = true
      this.hp_type = true
      this.office_id = true
      this.gender = true
      this.school_type = true
      this.school_name = true
      this.school_stage = true
      this.grade = true
      this.memo = true
      this.dm = true
      this.shop_type = true
      this.shop_name = true
      this.contact_method = true
      this.hp_browse = true
      this.visit_date = true
      this.visit_time = true
      this.next_visit_date = true
      this.next_visit_time = true
      this.person = true
      this.note = true
      this.sending_products = true
      this.sending_method = true
      this.sending_date = true
      this.sending_time = true
      this.contact_person = true
      this.parking = true
      this.parking_note = true
      this.sub_f_name = true
      this.sub_l_name = true
      this.sub_f_name_kana = true
      this.sub_l_name_kana = true
      this.sub_gender = true
      this.sub_school_type = true
      this.sub_school_name = true
      this.sub_school_stage = true
      this.sub_grade = true
      this.achievement = true
      this.learning = true
      this.learning_start_period = true
      this.learning_nervous = true
      this.learning_result = true
      this.learning_continuation = true
      this.sub_achievement = true
      this.sub_learning = true
      this.sub_learning_start_period = true
      this.sub_learning_nervous = true
      this.sub_learning_result = true
      this.sub_learning_continuation = true
      this.attended = true
      this.fathers_involvement = true
      this.notices = true
      this.transmission_item_company = true
      this.transmission_item_course = true
      this.transmission_item_visitor = true
      this.transmission_item_purpose = true
      this.transmission_item_requiredtime = true
      this.created_at = true
    },

    // order By
    sort (header) {
      if (this.sortState === '' || this.sortState === '降順') {
        this.sortState = '昇順'
        this.sortColumn = header
      } else if (this.sortState === '昇順') {
        this.sortState = '降順'
        this.sortColumn = header
      }
    },

    offset (e) {
      this.$store.dispatch('SCROLL', {
        this: this,
        e: e,
        obj: obj
      })
    },

    searchTable (e) {
      this.$store.dispatch('SEARCH', {
        this: this,
        e: e,
        obj: obj
      })
    },

    resetSearch () {
      this.watch.sending_check = 0
      this.search.sending_products = ''
      this.watch.sending_method = 0
      this.search.sending_date = ''
      this.search.sending_time = ''
      this.watch.confirm_check = 0
      this.watch.state = 0
      this.search.name = ''
      this.search.kana = ''
      this.search.zip = ''
      this.watch.pref = 0
      this.search.address = ''
      this.search.tel1 = ''
      this.search.tel2 = ''
      this.watch.preferred_contact = 0
      this.search.contact_timezone = ''
      this.search.fax = ''
      this.search.mail = ''
      this.search.contact_date = ''
      this.watch.support = 0
      this.watch.missing_detail = 0
      this.watch.contact_later = 0
      this.search.next_contact_date = ''
      this.watch.result = 0
      this.search.acquisition_date = []
      this.watch.ap_type = 0
      this.watch.medium1 = 0
      this.watch.medium2 = 0
      this.watch.medium3 = 0
      this.watch.hp_type = 0
      this.watch.office_id = 0
      this.watch.gender = 0
      this.watch.school_type = 0
      this.search.school_name = ''
      this.watch.school_stage = 0
      this.watch.grade = 0
      this.search.memo = ''
      this.search.dm = ''
      this.watch.shop_type = 0
      this.search.shop_name = ''
      this.watch.contact_method = 0
      this.watch.hp_browse = 0
      this.search.person = ''
      this.search.note = ''
      this.search.visit_date = ''
      this.search.visit_time = ''
      this.search.next_visit_date = ''
      this.search.next_visit_time = ''
      this.watch.contact_person = 0
      this.watch.parking = 0
      this.search.parking_note = ''
      this.search.sub_f_name = ''
      this.search.sub_l_name = ''
      this.search.sub_f_name_kana = ''
      this.search.sub_l_name_kana = ''
      this.watch.sub_gender = 0
      this.watch.sub_school_type = 0
      this.search.sub_school_name = ''
      this.watch.sub_school_stage = 0
      this.watch.sub_grade = 0
      this.search.achievement = ''
      this.search.learning = ''
      this.search.learning_start_period = ''
      this.search.learning_nervous = ''
      this.watch.learning_result = 0
      this.watch.learning_continuation = 0
      this.search.sub_achievement = ''
      this.search.sub_learning = ''
      this.search.sub_learning_start_period = ''
      this.search.sub_learning_nervous = ''
      this.watch.sub_learning_result = 0
      this.watch.sub_learning_continuation = 0
      this.search.attended = ''
      this.watch.fathers_involvement = 0
      this.watch.notices = 0
      this.watch.transmission_item_company = 0
      this.watch.transmission_item_course = 0
      this.watch.transmission_item_visitor = 0
      this.watch.transmission_item_purpose = 0
      this.watch.transmission_item_requiredtime = 0

      this.watch.not_sending_check = 0
      this.search.not_sending_products = ''
      this.watch.not_sending_method = 0
      this.search.not_sending_date = ''
      this.search.not_sending_time = ''
      this.watch.not_confirm_check = 0
      this.watch.not_state = 0
      this.search.not_name = ''
      this.search.not_kana = ''
      this.search.not_zip = ''
      this.watch.not_pref = 0
      this.search.not_address = ''
      this.search.not_tel1 = ''
      this.search.not_tel2 = ''
      this.watch.not_preferred_contact = 0
      this.search.not_contact_timezone = ''
      this.search.not_fax = ''
      this.search.not_mail = ''
      this.search.not_contact_date = ''
      this.watch.not_support = 0
      this.watch.not_missing_detail = 0
      this.watch.not_contact_later = 0
      this.search.not_next_contact_date = ''
      this.watch.not_result = 0
      this.search.not_acquisition_date = []
      this.watch.not_ap_type = 0
      this.watch.not_medium1 = 0
      this.watch.not_medium2 = 0
      this.watch.not_medium3 = 0
      this.watch.not_hp_type = 0
      this.watch.not_office_id = 0
      this.watch.not_gender = 0
      this.watch.not_school_type = 0
      this.search.not_school_name = ''
      this.watch.not_school_stage = 0
      this.watch.not_grade = 0
      this.search.not_memo = ''
      this.search.not_dm = ''
      this.watch.not_shop_type = 0
      this.search.not_shop_name = ''
      this.watch.not_contact_method = 0
      this.watch.not_hp_browse = 0
      this.search.not_person = ''
      this.search.not_note = ''
      this.search.not_visit_date = ''
      this.search.not_visit_time = ''
      this.watch.not_contact_person = 0
      this.watch.not_parking = 0
      this.search.not_parking_note = ''
      this.search.not_sub_f_name = ''
      this.search.not_sub_l_name = ''
      this.search.not_sub_f_name_kana = ''
      this.search.not_sub_l_name_kana = ''
      this.watch.not_sub_gender = 0
      this.watch.not_sub_school_type = 0
      this.search.not_sub_school_name = ''
      this.watch.not_sub_school_stage = 0
      this.watch.not_sub_grade = 0
      this.search.not_achievement = ''
      this.search.not_learning = ''
      this.search.not_learning_start_period = ''
      this.search.not_learning_nervous = ''
      this.watch.not_learning_result = 0
      this.watch.not_learning_continuation = 0
      this.search.not_sub_achievement = ''
      this.search.not_sub_learning = ''
      this.search.not_sub_learning_start_period = ''
      this.search.not_sub_learning_nervous = ''
      this.watch.not_sub_learning_result = 0
      this.watch.not_sub_learning_continuation = 0
      this.search.not_attended = ''
      this.watch.not_fathers_involvement = 0
      this.watch.not_notices = 0
      this.watch.not_transmission_item_company = 0
      this.watch.not_transmission_item_course = 0
      this.watch.not_transmission_item_visitor = 0
      this.watch.not_transmission_item_purpose = 0
      this.watch.not_transmission_item_requiredtime = 0

      this.searchTable()
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      // alert('get')
      let getjson = localStorage.getItem('ConfirmsSearch')
      let obj = JSON.parse(getjson)

      vm.watch.sending_check = obj['sending_check']
      vm.search.sending_products = obj['sending_products']
      vm.watch.sending_method = obj['sending_method']
      vm.search.sending_date = obj['sending_date']
      vm.search.sending_time = obj['sending_time']
      vm.watch.confirm_check = obj['confirm_check']
      vm.watch.state = obj['state']
      vm.search.name = obj['name']
      vm.search.kana = obj['kana']
      vm.search.zip = obj['zip']
      vm.watch.pref = obj['pref']
      vm.search.address = obj['address']
      vm.search.tel1 = obj['tel1']
      vm.search.tel2 = obj['tel2']
      vm.watch.preferred_contact = obj['preferred_contact']
      vm.search.contact_timezone = obj['contact_timezone']
      vm.search.fax = obj['fax']
      vm.search.mail = obj['mail']
      vm.search.contact_date = obj['contact_date']
      vm.watch.support = obj['support']
      vm.watch.missing_detail = obj['missing_detail']
      vm.watch.contact_later = obj['contact_later']
      vm.search.next_contact_date = obj['next_contact_date']
      vm.watch.result = obj['result']
      vm.search.acquisition_date = obj['acquisition_date']
      vm.watch.ap_type = obj['ap_type']
      vm.watch.medium1 = obj['medium1']
      vm.watch.medium2 = obj['medium2']
      vm.watch.medium3 = obj['medium3']
      vm.watch.hp_type = obj['hp_type']
      vm.watch.office_id = obj['office_id']
      vm.watch.gender = obj['gender']
      vm.watch.school_type = obj['school_type']
      vm.search.school_name = obj['school_name']
      vm.watch.school_stage = obj['school_stage']
      vm.watch.grade = obj['grade']
      vm.search.memo = obj['memo']
      vm.search.dm = obj['dm']
      vm.watch.shop_type = obj['shop_type']
      vm.search.shop_name = obj['shop_name']
      vm.watch.contact_method = obj['contact_method']
      vm.watch.hp_browse = obj['hp_browse']
      vm.search.person = obj['person']
      vm.search.note = obj['note']
      vm.search.visit_date = obj['visit_date']
      vm.search.visit_time = obj['visit_time']
      vm.search.next_visit_date = obj['next_visit_date']
      vm.search.next_visit_time = obj['next_visit_time']
      vm.watch.contact_person = obj['contact_person']
      vm.watch.parking = obj['parking']
      vm.search.parking_note = obj['parking_note']
      vm.search.sub_f_name = obj['sub_f_name']
      vm.search.sub_l_name = obj['sub_l_name']
      vm.search.sub_f_name_kana = obj['sub_f_name_kana']
      vm.search.sub_l_name_kana = obj['sub_l_name_kana']
      vm.watch.sub_gender = obj['sub_gender']
      vm.watch.sub_school_type = obj['sub_school_type']
      vm.search.sub_school_name = obj['sub_school_name']
      vm.watch.sub_school_stage = obj['sub_school_stage']
      vm.watch.sub_grade = obj['sub_grade']
      vm.search.achievement = obj['achievement']
      vm.search.learning = obj['learning']
      vm.search.learning_start_period = obj['learning_start_period']
      vm.search.learning_nervous = obj['learning_nervous']
      vm.watch.learning_result = obj['learning_result']
      vm.watch.learning_continuation = obj['learning_continuation']
      vm.search.sub_achievement = obj['sub_achievement']
      vm.search.sub_learning = obj['sub_learning']
      vm.search.sub_learning_start_period = obj['sub_learning_start_period']
      vm.search.sub_learning_nervous = obj['sub_learning_nervous']
      vm.watch.sub_learning_result = obj['sub_learning_result']
      vm.watch.sub_learning_continuation = obj['sub_learning_continuation']
      vm.search.attended = obj['attended']
      vm.watch.fathers_involvement = obj['fathers_involvement']
      vm.watch.notices = obj['notices']
      vm.watch.transmission_item_company = obj['transmission_item_company']
      vm.watch.transmission_item_course = obj['transmission_item_course']
      vm.watch.transmission_item_visitor = obj['transmission_item_visitor']
      vm.watch.transmission_item_purpose = obj['transmission_item_purpose']
      vm.watch.transmission_item_requiredtime = obj['transmission_item_requiredtime']

      vm.watch.not_sending_check = obj['not_sending_check']
      vm.search.not_sending_products = obj['not_sending_products']
      vm.watch.not_sending_method = obj['not_sending_method']
      vm.search.not_sending_date = obj['not_sending_date']
      vm.search.not_sending_time = obj['not_sending_time']
      vm.watch.not_confirm_check = obj['not_confirm_check']
      vm.watch.not_state = obj['not_state']
      vm.search.not_name = obj['not_name']
      vm.search.not_kana = obj['not_kana']
      vm.search.not_zip = obj['not_zip']
      vm.watch.not_pref = obj['not_pref']
      vm.search.not_address = obj['not_address']
      vm.search.not_tel1 = obj['not_tel1']
      vm.search.not_tel2 = obj['not_tel2']
      vm.watch.not_preferred_contact = obj['not_preferred_contact']
      vm.search.not_contact_timezone = obj['not_contact_timezone']
      vm.search.not_fax = obj['not_fax']
      vm.search.not_mail = obj['not_mail']
      vm.search.not_contact_date = obj['not_contact_date']
      vm.watch.not_support = obj['not_support']
      vm.watch.not_missing_detail = obj['not_missing_detail']
      vm.watch.not_contact_later = obj['not_contact_later']
      vm.search.not_next_contact_date = obj['not_next_contact_date']
      vm.watch.not_result = obj['not_result']
      vm.search.not_acquisition_date = obj['not_acquisition_date']
      vm.watch.not_ap_type = obj['not_ap_type']
      vm.watch.not_medium1 = obj['not_medium1']
      vm.watch.not_medium2 = obj['not_medium2']
      vm.watch.not_medium3 = obj['not_medium3']
      vm.watch.not_hp_type = obj['not_hp_type']
      vm.watch.not_office_id = obj['not_office_id']
      vm.watch.not_gender = obj['not_gender']
      vm.watch.not_school_type = obj['not_school_type']
      vm.search.not_school_name = obj['not_school_name']
      vm.watch.not_school_stage = obj['not_school_stage']
      vm.watch.not_grade = obj['not_grade']
      vm.search.not_memo = obj['not_memo']
      vm.search.not_dm = obj['not_dm']
      vm.watch.not_shop_type = obj['not_shop_type']
      vm.search.not_shop_name = obj['not_shop_name']
      vm.watch.not_contact_method = obj['not_contact_method']
      vm.watch.not_hp_browse = obj['not_hp_browse']
      vm.search.not_person = obj['not_person']
      vm.search.not_note = obj['not_note']
      vm.search.not_visit_date = obj['not_visit_date']
      vm.search.not_visit_time = obj['not_visit_time']
      vm.watch.not_contact_person = obj['not_contact_person']
      vm.watch.not_parking = obj['not_parking']
      vm.search.not_parking_note = obj['not_parking_note']
      vm.search.not_sub_f_name = obj['not_sub_f_name']
      vm.search.not_sub_l_name = obj['not_sub_l_name']
      vm.search.not_sub_f_name_kana = obj['not_sub_f_name_kana']
      vm.search.not_sub_l_name_kana = obj['not_sub_l_name_kana']
      vm.watch.not_sub_gender = obj['not_sub_gender']
      vm.watch.not_sub_school_type = obj['not_sub_school_type']
      vm.search.not_sub_school_name = obj['not_sub_school_name']
      vm.watch.not_sub_school_stage = obj['not_sub_school_stage']
      vm.watch.not_sub_grade = obj['not_sub_grade']
      vm.search.not_achievement = obj['not_achievement']
      vm.search.not_learning = obj['not_learning']
      vm.search.not_learning_start_period = obj['not_learning_start_period']
      vm.search.not_learning_nervous = obj['not_learning_nervous']
      vm.watch.not_learning_result = obj['not_learning_result']
      vm.watch.not_learning_continuation = obj['not_learning_continuation']
      vm.search.not_sub_achievement = obj['not_sub_achievement']
      vm.search.not_sub_learning = obj['not_sub_learning']
      vm.search.not_sub_learning_start_period = obj['not_sub_learning_start_period']
      vm.search.not_sub_learning_nervous = obj['not_sub_learning_nervous']
      vm.watch.not_sub_learning_result = obj['not_sub_learning_result']
      vm.watch.not_sub_learning_continuation = obj['not_sub_learning_continuation']
      vm.search.not_attended = obj['not_attended']
      vm.watch.not_fathers_involvement = obj['not_fathers_involvement']
      vm.watch.not_notices = obj['not_notices']
      vm.watch.not_transmission_item_company = obj['not_transmission_item_company']
      vm.watch.not_transmission_item_course = obj['not_transmission_item_course']
      vm.watch.not_transmission_item_visitor = obj['not_transmission_item_visitor']
      vm.watch.not_transmission_item_purpose = obj['not_transmission_item_purpose']
      vm.watch.not_transmission_item_requiredtime = obj['not_transmission_item_requiredtime']

      // console.log(obj)
      vm.searchTable()
    })
  },
  beforeRouteLeave (to, from, next) {
    // alert('save')
    let arr = []
    let obj = {

      sending_check: this.watch.sending_check,
      sending_products: this.search.sending_products,
      sending_method: this.watch.sending_method,
      sending_date: this.search.sending_date,
      sending_time: this.search.sending_time,
      confirm_check: this.watch.confirm_check,
      state: this.watch.state,
      name: this.search.name,
      kana: this.search.kana,
      zip: this.search.zip,
      pref: this.watch.pref,
      address: this.search.address,
      tel1: this.search.tel1,
      tel2: this.search.tel2,
      preferred_contact: this.watch.preferred_contact,
      contact_timezone: this.search.contact_timezone,
      fax: this.search.fax,
      mail: this.search.mail,
      contact_date: this.search.contact_date,
      support: this.watch.support,
      missing_detail: this.watch.missing_detail,
      contact_later: this.watch.contact_later,
      next_contact_date: this.search.next_contact_date,
      result: this.watch.result,
      acquisition_date: this.search.acquisition_date,
      ap_type: this.watch.ap_type,
      medium1: this.watch.medium1,
      medium2: this.watch.medium2,
      medium3: this.watch.medium3,
      hp_type: this.watch.hp_type,
      office_id: this.watch.office_id,
      gender: this.watch.gender,
      school_type: this.watch.school_type,
      school_name: this.search.school_name,
      school_stage: this.watch.school_stage,
      grade: this.watch.grade,
      memo: this.search.memo,
      dm: this.search.dm,
      shop_type: this.watch.shop_type,
      shop_name: this.search.shop_name,
      contact_method: this.watch.contact_method,
      hp_browse: this.watch.hp_browse,
      person: this.search.person,
      note: this.search.note,
      visit_date: this.search.visit_date,
      visit_time: this.search.visit_time,
      next_visit_date: this.search.next_visit_date,
      next_visit_time: this.search.next_visit_time,
      contact_person: this.watch.contact_person,
      parking: this.watch.parking,
      parking_note: this.search.parking_note,
      sub_f_name: this.search.sub_f_name,
      sub_l_name: this.search.sub_l_name,
      sub_f_name_kana: this.search.sub_f_name_kana,
      sub_l_name_kana: this.search.sub_l_name_kana,
      sub_gender: this.watch.sub_gender,
      sub_school_type: this.watch.sub_school_type,
      sub_school_name: this.search.sub_school_name,
      sub_school_stage: this.watch.sub_school_stage,
      sub_grade: this.watch.sub_grade,
      achievement: this.search.achievement,
      learning: this.search.learning,
      learning_start_period: this.search.learning_start_period,
      learning_nervous: this.search.learning_nervous,
      learning_result: this.watch.learning_result,
      learning_continuation: this.watch.learning_continuation,
      sub_achievement: this.search.sub_achievement,
      sub_learning: this.search.sub_learning,
      sub_learning_start_period: this.search.sub_learning_start_period,
      sub_learning_nervous: this.search.sub_learning_nervous,
      sub_learning_result: this.watch.sub_learning_result,
      sub_learning_continuation: this.watch.sub_learning_continuation,
      attended: this.search.attended,
      fathers_involvement: this.watch.fathers_involvement,
      notices: this.watch.notices,
      transmission_item_company: this.watch.transmission_item_company,
      transmission_item_course: this.watch.transmission_item_course,
      transmission_item_visitor: this.watch.transmission_item_visitor,
      transmission_item_purpose: this.watch.transmission_item_purpose,
      transmission_item_requiredtime: this.watch.transmission_item_requiredtime,

      not_sending_check: this.watch.not_sending_check,
      not_sending_products: this.search.not_sending_products,
      not_sending_method: this.watch.not_sending_method,
      not_sending_date: this.search.not_sending_date,
      not_sending_time: this.search.not_sending_time,
      not_confirm_check: this.watch.not_confirm_check,
      not_state: this.watch.not_state,
      not_name: this.search.not_name,
      not_kana: this.search.not_kana,
      not_zip: this.search.not_zip,
      not_pref: this.watch.not_pref,
      not_address: this.search.not_address,
      not_tel1: this.search.not_tel1,
      not_tel2: this.search.not_tel2,
      not_preferred_contact: this.watch.not_preferred_contact,
      not_contact_timezone: this.search.not_contact_timezone,
      not_fax: this.search.not_fax,
      not_mail: this.search.not_mail,
      not_contact_date: this.search.not_contact_date,
      not_support: this.watch.not_support,
      not_missing_detail: this.watch.not_missing_detail,
      not_contact_later: this.watch.not_contact_later,
      not_next_contact_date: this.search.not_next_contact_date,
      not_result: this.watch.not_result,
      not_acquisition_date: this.search.not_acquisition_date,
      not_ap_type: this.watch.not_ap_type,
      not_medium1: this.watch.not_medium1,
      not_medium2: this.watch.not_medium2,
      not_medium3: this.watch.not_medium3,
      not_hp_type: this.watch.not_hp_type,
      not_office_id: this.watch.not_office_id,
      not_gender: this.watch.not_gender,
      not_school_type: this.watch.not_school_type,
      not_school_name: this.search.not_school_name,
      not_school_stage: this.watch.not_school_stage,
      not_grade: this.watch.not_grade,
      not_memo: this.search.not_memo,
      not_dm: this.search.not_dm,
      not_shop_type: this.watch.not_shop_type,
      not_shop_name: this.search.not_shop_name,
      not_contact_method: this.watch.not_contact_method,
      not_hp_browse: this.watch.not_hp_browse,
      not_person: this.search.not_person,
      not_note: this.search.not_note,
      not_visit_date: this.search.not_visit_date,
      not_visit_time: this.search.not_visit_time,
      not_contact_person: this.watch.not_contact_person,
      not_parking: this.watch.not_parking,
      not_parking_note: this.search.not_parking_note,
      not_sub_f_name: this.search.not_sub_f_name,
      not_sub_l_name: this.search.not_sub_l_name,
      not_sub_f_name_kana: this.search.not_sub_f_name_kana,
      not_sub_l_name_kana: this.search.not_sub_l_name_kana,
      not_sub_gender: this.watch.not_sub_gender,
      not_sub_school_type: this.watch.not_sub_school_type,
      not_sub_school_name: this.search.not_sub_school_name,
      not_sub_school_stage: this.watch.not_sub_school_stage,
      not_sub_grade: this.watch.not_sub_grade,
      not_achievement: this.search.not_achievement,
      not_learning: this.search.not_learning,
      not_learning_start_period: this.search.not_learning_start_period,
      not_learning_nervous: this.search.not_learning_nervous,
      not_learning_result: this.watch.not_learning_result,
      not_learning_continuation: this.watch.not_learning_continuation,
      not_sub_achievement: this.search.not_sub_achievement,
      not_sub_learning: this.search.not_sub_learning,
      not_sub_learning_start_period: this.search.not_sub_learning_start_period,
      not_sub_learning_nervous: this.search.not_sub_learning_nervous,
      not_sub_learning_result: this.watch.not_sub_learning_result,
      not_sub_learning_continuation: this.watch.not_sub_learning_continuation,
      not_attended: this.search.not_attended,
      not_fathers_involvement: this.watch.not_fathers_involvement,
      not_notices: this.watch.not_notices,
      not_transmission_item_company: this.watch.not_transmission_item_company,
      not_transmission_item_course: this.watch.not_transmission_item_course,
      not_transmission_item_visitor: this.watch.not_transmission_item_visitor,
      not_transmission_item_purpose: this.watch.not_transmission_item_purpose,
      not_transmission_item_requiredtime: this.watch.not_transmission_item_requiredtime
    }
    arr.push(obj)
    let setjson = JSON.stringify(obj)
    localStorage.setItem('ConfirmsSearch', setjson)
    next()
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
/* .sticky-1 { */
/*   position: sticky; */
/*   top: 0; */
/*   background: #fff; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/* } */
/* .sticky-2 { */
/*   position: sticky; */
/*   top: 24px; */
/*   background: #fff; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/* } */
/* .sticky-3 { */
/*   position: sticky; */
/*   top: 49px; */
/*   &:before { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     top: -1px; */
/*   } */
/*   &:after { */
/*     content: ''; */
/*     position: absolute; */
/*     display: block; */
/*     background: #ccc; */
/*     height: 1px; */
/*     width: 100%; */
/*     left: 0; */
/*     bottom: -1px; */
/*   } */
/* } */

.confirm {
  background: #36474f;
  color: #fff;
}
.fix {
  height: 14px;
  overflow: auto;
}

.m-label-custom {
  z-index: 1;
  cursor: pointer;
  margin-bottom: 1px;
}
.slideActive {
  background: #455A64;
  color: #fff;
}
.active {
  background: #455A64;
  border: solid 1px #455A64;
  color: #fff;
}
.resetSearch {
  padding: 7px 0;
}
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
.select {
  padding: 0 !important;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.index-box {
  /* box-shadow: 1px 1px 1px #ccc; */
  /* border: solid 1px #ccc; */
  height: calc(100vh - 245px);
  overflow: scroll;
  margin-top: 10px;
  &:after {
    content: "\f1b9";
    font-family: FontAwesome;
    position: absolute;
    font-size: 500px;
    top: 50%;
    left: 50%;
    margin-top: -250px;
    margin-left: -250px;
    color: #ddd;
    opacity: 0.1;
    z-index: -1;
  }
}
</style>

<style lang="scss">
.ConfirmsIndex {
  .multiselect {
    min-height: 23px;
    min-width: 100px;
  }
  .multiselect__tags {
    border: solid 1px #ccc;
    min-height: 23px;
    padding: 0px 23px 0 2px;
    border-radius: 0;
    border: none;
    /* text-align: center; */
    /* margin: 1px; */
  }
  .multiselect__tags-wrap {
    background: red;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 23px;
  }
  .multiselect__select {
    height: 23px;
    width: 26px;
    top: 2px;
    padding: 0;
    &:before {
      top: 75%;
    }
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// ConfirmsIndex.vue?75805516